<template>
  <div class="fish-content">
    <div id="stars"></div>
    <div id="stars2"></div>
    <div id="stars3"></div>
    <div class="fish-header">
      <span>钓鱼台数据可视化大屏</span>
      <span>{{ homeTime }} {{ weather }} {{ temp }}℃</span>
    </div>
    <div class="fish-body">
      <div class="fish-body-left">
        <div class="fish-body-left-box1">
          <div class="le-box1">
            <div class="qiu-box" ref="qiu1"></div>
            <div class="qiu-box" ref="qiu2"></div>
            <div class="qiu-box" ref="qiu3"></div>
            <div class="qiu-box" ref="qiu4"></div>
          </div>
          <div class="le-box2" ref="dLine"></div>
        </div>
      </div>
      <div class="fish-body-right">
        <div class="fish-body-right-box">
          <div class="right-box-le">
            <div class="right-box-title">
              各楼层制冷量柱状图（单位：kWh）
            </div>
            <div class="ech-box" ref="ech1"></div>
          </div>
          <div class="line"></div>
          <div class="right-box-ri">
            <div class="right-box-title">
              各楼层制冷量占比图
            </div>
            <div class="ech-box" ref="ech2"></div>
          </div>
        </div>
        <div class="fish-body-right-box">
          <div style="width: 100%;height: 100%;">
            <div class="right-box-title">
              用电量曲线图
            </div>
            <div class="ech-box" ref="ech3"></div>
          </div>
        </div>
        <div class="fish-body-right-box">
          <div style="width: 100%;height: 100%;">
            <div class="right-box-title">
              能耗曲线图
            </div>
            <div class="ech-box" ref="ech4"></div>
          </div>
        </div>
        <div class="fish-body-right-box">
          <div class="right-box-le">
            <div class="right-box-title">
              各层碳排放量柱状图（单位：kg/㎡/天）
            </div>
            <div class="ech-box" ref="ech6"></div>
          </div>
          <div class="line"></div>
          <div class="right-box-ri">
            <div class="right-box-title">
              各层碳排放量占比图
            </div>
            <div class="ech-box" ref="ech7"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
export default {
  name: '',
  props: [''],
  data() {
    return {
      homeTime: '',
      weather: '',
      temp: '',
      hours: ['三层', '二层', '一层', 'B1层', 'B2层'],
      days: [1, 2, 3, 4, 5, 6, 7],
      data: [[0, 0, 5], [0, 1, 1], [0, 2, 0], [0, 3, 0], [0, 4, 0], [0, 5, 0], [0, 6, 0], [0, 7, 0], [0, 8, 0], [0, 9, 0], [0, 10, 0], [0, 11, 2], [0, 12, 4], [0, 13, 1], [0, 14, 1], [0, 15, 3], [0, 16, 4], [0, 17, 6], [0, 18, 4], [0, 19, 4], [0, 20, 3], [0, 21, 3], [0, 22, 2], [0, 23, 5], [1, 0, 7], [1, 1, 0], [1, 2, 0],],
      data1: [
        {
          name: "房间1",
          value: [0, 0, 5],
        },
        {
          name: "房间2",
          value: [0, 0, 15],
        },
        {
          name: "房间3",
          value: [3, 1, 13],
        },
        {
          name: "房间4",
          value: [7, 9, 12],
        },
        {
          name: "房间5",
          value: [0, 0, 13],
        },
      ],
      tempData: '26.35℃',
      humdData: '30.48%',
      co2Data: '485ppm',
      vocData: '685ppm',
      tempValue: 26,
      humdValue: 30,
      co2Value: 48,
      vocValue: 68,
    };
  },

  components: {},

  computed: {},

  beforeMount() { },

  mounted() {
    this.hefeng()
    this.$nextTick(() => {
      this.echartsInit()
    })
    setInterval(() => {
      this.getTime()
    }, 1000)
  },

  methods: {
    echartsInit() {
      let _this = this
      let pieOne1 = echarts.init(this.$refs.ech1);
      pieOne1.setOption(
        {
          color: ["#2B52E1"],
          grid: {
            top: '15%',
            left: '1%', //grid 组件离容器左侧的距离。
            right: '4%', //grid 组件离容器右侧的距离。
            bottom: '3%', //grid 组件离容器下侧的距离。
            containLabel: true //grid 区域是否包含坐标轴的刻度标签[ default: false ] 
          },
          tooltip: {
            trigger: 'item',
            formatter: function (params) {
              // params 是包含数据信息的对象
              // return '自定义内容：' + params.name + ' - ' + params.value;
              return `${params.value}kW·h`
            }
          },
          xAxis: {
            type: 'category',
            data: ['三层', '二层', '一层', 'B1', 'B2'],
            axisLine: {
              lineStyle: {
                color: '#d2d2d2' //坐标轴线线的颜色。
              }
            },
          },
          yAxis: [{
            type: 'value', //坐标轴类型。'value' 数值轴，适用于连续数据;'category' 类目轴，适用于离散的类目数据，为该类型时必须通过 data 设置类目数据;'time' 时间轴;'log' 对数轴.
            name: '', //坐标轴名称。
            axisTick: {
              show: false //是否显示坐标轴刻度
            },
            axisLine: {
              lineStyle: {
                show: false,
                color: '#d2d2d2', //坐标轴线线的颜色
                textStyle: {
                  fontSize: 18, //文字的字体大小
                  fontWeight: '900',
                }
              }
            },
            axisLabel: {
              show: true,
              margin: 10, //刻度标签与轴线之间的距离
              color: '#d2d2d2',
              textStyle: {
                fontSize: 12, //文字的字体大小
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#143592' //分隔线颜色设置
              }
            }
          }],
          series: [
            {
              data: ['607', '986', '756', '1235', '385'],
              type: 'bar',
              barWidth: '50%', // 设置为类目宽度的50%
              label: {
                show: true, // 显示数据
                position: 'top', // 数据显示在柱状图上方
                textStyle: { color: '#D2D2D2' }
              },
              itemStyle: { // 使用方法一的写法
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#3CA8E0' },
                  { offset: 1, color: '#3ca9e000' }
                ])
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieOne1.resize()
      })

      let pieOne2 = echarts.init(this.$refs.ech2);
      pieOne2.setOption(
        {
          color: ["#FEDA66", "#FDA4A5", "#F99EE4", "#78CDF2", "#26EAB1"],
          grid: {
            top: '5%',
            left: '3%', //grid 组件离容器左侧的距离。
            right: '4%', //grid 组件离容器右侧的距离。
            bottom: '0%', //grid 组件离容器下侧的距离。
            containLabel: true //grid 区域是否包含坐标轴的刻度标签[ default: false ] 
          },
          title: {
            text: '',
            top: 'middle',
            left: 'center',
            textStyle: {
              color: '#FEDA66',
              fontSize: 15
            }
          },
          tooltip: {
            trigger: 'item',
            formatter: function (params) {
              // params 是包含数据信息的对象
              // return '自定义内容：' + params.name + ' - ' + params.value;
              if (params.id == 0) {
                return ""
              } else {
                return `${params.value}kWh`
              }
            }
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            show: false
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['30%', '70%'],
              avoidLabelOverlap: false,
              data: [
                { value: 607, name: '三层' },
                { value: 986, name: '二层' },
                { value: 756, name: '一层' },
                { value: 1235, name: 'B1' },
                { value: 385, name: `B2` }
              ],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
              labelLine: {
                normal: {
                  show: true,
                  minLength: 0, // 设置最小长度，0表示始终显示
                  length: 5,   // 指引线长度
                  length2: 10,  // 第二条指引线长度，长度为从内半径到此处的线长
                  smooth: 0.2,  // 指引线平滑度
                  lineStyle: {
                    // 指引线样式
                    width: 1,
                    type: 'solid'
                  }
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieOne2.resize()
      })

      pieOne2.on('click', function (params) {
        _this.onclickEcharts(params)
      })

      let obj = [
        [
          "2024-09-10 10:10:36",
          "59.45"
        ],
        [
          "2024-09-10 10:14:50",
          "58.83"
        ],
        [
          "2024-09-10 10:19:50",
          "59.78"
        ],
        [
          "2024-09-10 10:24:50",
          "59.81"
        ],
        [
          "2024-09-10 10:29:50",
          "58.67"
        ],
        [
          "2024-09-10 10:34:50",
          "59.03"
        ],
        [
          "2024-09-10 10:39:50",
          "59.82"
        ],
        [
          "2024-09-10 10:44:50",
          "59.44"
        ],
        [
          "2024-09-10 10:49:50",
          "59.77"
        ],
        [
          "2024-09-10 10:55:24",
          "59.77"
        ],
        [
          "2024-09-10 11:00:38",
          "59.07"
        ],
        [
          "2024-09-10 11:04:50",
          "59.23"
        ],
        [
          "2024-09-10 11:09:50",
          "59.36"
        ],
        [
          "2024-09-10 11:14:50",
          "58.76"
        ],
        [
          "2024-09-10 11:19:50",
          "57.97"
        ],
        [
          "2024-09-10 11:24:50",
          "56.8"
        ],
        [
          "2024-09-10 11:29:50",
          "56.17"
        ],
        [
          "2024-09-10 11:35:40",
          "54.74"
        ],
        [
          "2024-09-10 11:39:50",
          "54.0"
        ],
        [
          "2024-09-10 11:44:50",
          "54.99"
        ],
        [
          "2024-09-10 11:50:14",
          "53.83"
        ],
        [
          "2024-09-10 11:54:50",
          "53.02"
        ],
        [
          "2024-09-10 11:59:50",
          "52.97"
        ],
        [
          "2024-09-10 12:04:50",
          "51.47"
        ],
        [
          "2024-09-10 12:09:50",
          "50.5"
        ],
        [
          "2024-09-10 12:14:50",
          "49.9"
        ],
        [
          "2024-09-10 12:20:14",
          "48.96"
        ],
        [
          "2024-09-10 12:24:50",
          "48.91"
        ],
        [
          "2024-09-10 12:30:14",
          "21.04"
        ],
        [
          "2024-09-10 12:34:50",
          "21.08"
        ],
        [
          "2024-09-10 12:39:50",
          "19.89"
        ],
        [
          "2024-09-10 12:44:50",
          "20.91"
        ],
        [
          "2024-09-10 12:49:50",
          "19.49"
        ],
        [
          "2024-09-10 12:54:50",
          "18.33"
        ],
        [
          "2024-09-10 12:59:50",
          "17.89"
        ],
        [
          "2024-09-10 13:04:50",
          "18.91"
        ],
        [
          "2024-09-10 13:09:50",
          "18.11"
        ],
        [
          "2024-09-10 13:15:14",
          "18.95"
        ],
        [
          "2024-09-10 13:19:50",
          "18.05"
        ],
        [
          "2024-09-10 13:25:14",
          "19.13"
        ],
        [
          "2024-09-10 13:29:50",
          "19.89"
        ],
        [
          "2024-09-10 13:35:40",
          "52.74"
        ],
        [
          "2024-09-10 13:39:50",
          "55.93"
        ],
        [
          "2024-09-10 13:44:50",
          "57.07"
        ],
        [
          "2024-09-10 13:49:50",
          "56.77"
        ],
        [
          "2024-09-10 13:55:40",
          "59.45"
        ],
        [
          "2024-09-10 13:59:50",
          "58.89"
        ],
        [
          "2024-09-10 14:05:24",
          "59.23"
        ],
        [
          "2024-09-10 14:09:50",
          "60.2"
        ],
        [
          "2024-09-10 14:15:14",
          "60.43"
        ],
        [
          "2024-09-10 14:19:50",
          "59.61"
        ],
        [
          "2024-09-10 14:25:38",
          "58.74"
        ],
        [
          "2024-09-10 14:30:38",
          "58.75"
        ],
        [
          "2024-09-10 14:34:50",
          "60.81"
        ],
        [
          "2024-09-10 14:39:50",
          "59.0"
        ],
        [
          "2024-09-10 14:45:14",
          "59.45"
        ],
        [
          "2024-09-10 14:50:15",
          "59.63"
        ],
        [
          "2024-09-10 14:54:50",
          "60.26"
        ],
        [
          "2024-09-10 14:59:50",
          "59.48"
        ],
        [
          "2024-09-10 15:04:50",
          "60.98"
        ],
        [
          "2024-09-10 15:09:50",
          "59.58"
        ],
        [
          "2024-09-10 15:14:50",
          "59.78"
        ],
        [
          "2024-09-10 15:19:50",
          "59.65"
        ],
        [
          "2024-09-10 15:24:50",
          "60.05"
        ],
        [
          "2024-09-10 15:29:50",
          "58.64"
        ],
        [
          "2024-09-10 15:35:14",
          "57.69"
        ],
        [
          "2024-09-10 15:39:50",
          "58.46"
        ],
        [
          "2024-09-10 15:44:50",
          "59.98"
        ],
        [
          "2024-09-10 15:50:14",
          "58.68"
        ],
        [
          "2024-09-10 15:55:40",
          "60.31"
        ],
        [
          "2024-09-10 16:00:50",
          "57.85"
        ],
        [
          "2024-09-10 16:04:50",
          "58.6"
        ],
        [
          "2024-09-10 16:09:50",
          "59.8"
        ],
        [
          "2024-09-10 16:14:50",
          "58.52"
        ],
        [
          "2024-09-10 16:19:50",
          "58.04"
        ],
        [
          "2024-09-10 16:24:50",
          "57.82"
        ],
        [
          "2024-09-10 16:29:50",
          "58.38"
        ],
        [
          "2024-09-10 16:34:50",
          "57.6"
        ],
        [
          "2024-09-10 16:40:14",
          "58.01"
        ],
        [
          "2024-09-10 16:44:50",
          "56.87"
        ],
        [
          "2024-09-10 16:49:50",
          "53.87"
        ],
        [
          "2024-09-10 16:54:50",
          "55.19"
        ],
        [
          "2024-09-10 16:59:50",
          "54.33"
        ],
        [
          "2024-09-10 17:04:50",
          "52.25"
        ],
        [
          "2024-09-10 17:09:50",
          "51.93"
        ],
        [
          "2024-09-10 17:14:50",
          "49.88"
        ],
        [
          "2024-09-10 17:20:14",
          "49.53"
        ],
        [
          "2024-09-10 17:25:24",
          "52.03"
        ],
        [
          "2024-09-10 17:29:50",
          "49.35"
        ],
        [
          "2024-09-10 17:34:50",
          "48.94"
        ],
        [
          "2024-09-10 17:39:50",
          "47.01"
        ],
        [
          "2024-09-10 17:44:50",
          "46.79"
        ],
        [
          "2024-09-10 17:49:50",
          "44.8"
        ],
        [
          "2024-09-10 17:54:50",
          "44.76"
        ],
        [
          "2024-09-10 18:00:28",
          "44.57"
        ],
        [
          "2024-09-10 18:05:25",
          "44.24"
        ],
        [
          "2024-09-10 18:10:27",
          "43.34"
        ],
        [
          "2024-09-10 18:14:50",
          "43.34"
        ],
        [
          "2024-09-10 18:19:50",
          "44.02"
        ],
        [
          "2024-09-10 18:25:38",
          "42.33"
        ],
        [
          "2024-09-10 18:29:50",
          "42.01"
        ],
        [
          "2024-09-10 18:34:50",
          "40.78"
        ],
        [
          "2024-09-10 18:39:50",
          "41.29"
        ],
        [
          "2024-09-10 18:45:24",
          "42.36"
        ],
        [
          "2024-09-10 18:49:50",
          "41.61"
        ],
        [
          "2024-09-10 18:54:50",
          "42.22"
        ],
        [
          "2024-09-10 19:00:37",
          "42.69"
        ],
        [
          "2024-09-10 19:05:38",
          "41.12"
        ],
        [
          "2024-09-10 19:09:50",
          "41.33"
        ],
        [
          "2024-09-10 19:15:14",
          "40.66"
        ],
        [
          "2024-09-10 19:20:36",
          "41.05"
        ],
        [
          "2024-09-10 19:24:50",
          "40.74"
        ],
        [
          "2024-09-10 19:29:50",
          "39.92"
        ],
        [
          "2024-09-10 19:34:50",
          "40.44"
        ],
        [
          "2024-09-10 19:39:50",
          "39.28"
        ],
        [
          "2024-09-10 19:44:50",
          "40.13"
        ],
        [
          "2024-09-10 19:50:37",
          "38.65"
        ],
        [
          "2024-09-10 19:55:38",
          "38.86"
        ],
        [
          "2024-09-10 19:59:50",
          "37.44"
        ],
        [
          "2024-09-10 20:05:23",
          "36.78"
        ],
        [
          "2024-09-10 20:10:28",
          "36.05"
        ],
        [
          "2024-09-10 20:15:36",
          "35.97"
        ],
        [
          "2024-09-10 20:20:50",
          "35.65"
        ],
        [
          "2024-09-10 20:25:38",
          "35.91"
        ],
        [
          "2024-09-10 20:29:50",
          "36.09"
        ],
        [
          "2024-09-10 20:34:50",
          "35.62"
        ],
        [
          "2024-09-10 20:40:13",
          "35.31"
        ],
        [
          "2024-09-10 20:44:50",
          "35.36"
        ],
        [
          "2024-09-10 20:50:48",
          "34.69"
        ],
        [
          "2024-09-10 20:55:38",
          "34.47"
        ],
        [
          "2024-09-10 20:59:50",
          "33.52"
        ],
        [
          "2024-09-10 21:04:50",
          "33.33"
        ],
        [
          "2024-09-10 21:09:50",
          "33.65"
        ],
        [
          "2024-09-10 21:15:13",
          "33.32"
        ],
        [
          "2024-09-10 21:20:49",
          "34.15"
        ],
        [
          "2024-09-10 21:25:38",
          "32.83"
        ],
        [
          "2024-09-10 21:29:50",
          "32.69"
        ],
        [
          "2024-09-10 21:35:23",
          "29.94"
        ],
        [
          "2024-09-10 21:39:50",
          "27.61"
        ],
        [
          "2024-09-10 21:44:50",
          "28.31"
        ],
        [
          "2024-09-10 21:49:50",
          "27.87"
        ],
        [
          "2024-09-10 21:54:50",
          "29.23"
        ],
        [
          "2024-09-10 22:00:48",
          "28.32"
        ],
        [
          "2024-09-10 22:05:38",
          "27.15"
        ],
        [
          "2024-09-10 22:09:50",
          "28.66"
        ],
        [
          "2024-09-10 22:14:50",
          "22.87"
        ],
        [
          "2024-09-10 22:19:50",
          "23.68"
        ],
        [
          "2024-09-10 22:25:36",
          "23.52"
        ],
        [
          "2024-09-10 22:29:50",
          "21.53"
        ],
        [
          "2024-09-10 22:34:50",
          "22.73"
        ],
        [
          "2024-09-10 22:39:50",
          "23.46"
        ],
        [
          "2024-09-10 22:44:50",
          "23.68"
        ],
        [
          "2024-09-10 22:50:27",
          "22.89"
        ],
        [
          "2024-09-10 22:55:23",
          "23.34"
        ],
        [
          "2024-09-10 22:59:50",
          "22.37"
        ],
        [
          "2024-09-10 23:05:36",
          "26.74"
        ],
        [
          "2024-09-10 23:09:50",
          "24.67"
        ],
        [
          "2024-09-10 23:15:38",
          "24.71"
        ],
        [
          "2024-09-10 23:20:14",
          "25.68"
        ],
        [
          "2024-09-10 23:24:50",
          "20.59"
        ],
        [
          "2024-09-10 23:29:50",
          "19.5"
        ],
        [
          "2024-09-10 23:34:50",
          "20.67"
        ],
        [
          "2024-09-10 23:40:27",
          "19.85"
        ],
        [
          "2024-09-10 23:45:13",
          "18.13"
        ],
        [
          "2024-09-10 23:49:50",
          "20.09"
        ],
        [
          "2024-09-10 23:55:38",
          "19.16"
        ],
        [
          "2024-09-10 23:59:50",
          "18.75"
        ],
        [
          "2024-09-11 00:04:50",
          "18.28"
        ],
        [
          "2024-09-11 00:09:50",
          "18.03"
        ],
        [
          "2024-09-11 00:15:25",
          "17.44"
        ],
        [
          "2024-09-11 00:19:50",
          "16.79"
        ],
        [
          "2024-09-11 00:24:50",
          "17.62"
        ],
        [
          "2024-09-11 00:29:50",
          "18.22"
        ],
        [
          "2024-09-11 00:35:38",
          "16.75"
        ],
        [
          "2024-09-11 00:40:14",
          "16.75"
        ],
        [
          "2024-09-11 00:44:50",
          "16.74"
        ],
        [
          "2024-09-11 00:50:28",
          "15.72"
        ],
        [
          "2024-09-11 00:54:50",
          "15.61"
        ],
        [
          "2024-09-11 01:00:28",
          "15.07"
        ],
        [
          "2024-09-11 01:05:14",
          "15.5"
        ],
        [
          "2024-09-11 01:09:50",
          "14.85"
        ],
        [
          "2024-09-11 01:15:36",
          "16.87"
        ],
        [
          "2024-09-11 01:20:48",
          "16.97"
        ],
        [
          "2024-09-11 01:25:38",
          "16.35"
        ],
        [
          "2024-09-11 01:29:50",
          "16.25"
        ],
        [
          "2024-09-11 01:34:50",
          "16.81"
        ],
        [
          "2024-09-11 01:39:50",
          "15.33"
        ],
        [
          "2024-09-11 01:45:36",
          "14.84"
        ],
        [
          "2024-09-11 01:50:37",
          "16.17"
        ],
        [
          "2024-09-11 01:55:38",
          "16.81"
        ],
        [
          "2024-09-11 02:00:14",
          "17.54"
        ],
        [
          "2024-09-11 02:04:50",
          "17.95"
        ],
        [
          "2024-09-11 02:10:49",
          "18.23"
        ],
        [
          "2024-09-11 02:15:36",
          "18.48"
        ],
        [
          "2024-09-11 02:20:27",
          "18.07"
        ],
        [
          "2024-09-11 02:24:50",
          "16.36"
        ],
        [
          "2024-09-11 02:30:49",
          "16.79"
        ],
        [
          "2024-09-11 02:34:50",
          "17.31"
        ],
        [
          "2024-09-11 02:39:50",
          "17.16"
        ],
        [
          "2024-09-11 02:45:36",
          "17.11"
        ],
        [
          "2024-09-11 02:50:48",
          "16.69"
        ],
        [
          "2024-09-11 02:55:38",
          "16.29"
        ],
        [
          "2024-09-11 02:59:50",
          "16.12"
        ],
        [
          "2024-09-11 03:04:50",
          "17.47"
        ],
        [
          "2024-09-11 03:09:50",
          "17.35"
        ],
        [
          "2024-09-11 03:15:36",
          "17.95"
        ],
        [
          "2024-09-11 03:19:50",
          "16.16"
        ],
        [
          "2024-09-11 03:25:38",
          "16.79"
        ],
        [
          "2024-09-11 03:29:50",
          "17.35"
        ],
        [
          "2024-09-11 03:35:40",
          "16.73"
        ],
        [
          "2024-09-11 03:39:50",
          "16.9"
        ],
        [
          "2024-09-11 03:44:50",
          "16.26"
        ],
        [
          "2024-09-11 03:50:47",
          "15.84"
        ],
        [
          "2024-09-11 03:55:37",
          "16.95"
        ],
        [
          "2024-09-11 04:00:37",
          "16.13"
        ],
        [
          "2024-09-11 04:04:50",
          "16.71"
        ],
        [
          "2024-09-11 04:09:50",
          "16.52"
        ],
        [
          "2024-09-11 04:14:50",
          "15.19"
        ],
        [
          "2024-09-11 04:20:37",
          "16.47"
        ],
        [
          "2024-09-11 04:25:38",
          "17.22"
        ],
        [
          "2024-09-11 04:30:14",
          "17.83"
        ],
        [
          "2024-09-11 04:34:50",
          "17.71"
        ],
        [
          "2024-09-11 04:39:50",
          "15.81"
        ],
        [
          "2024-09-11 04:44:50",
          "15.89"
        ],
        [
          "2024-09-11 04:49:50",
          "18.35"
        ],
        [
          "2024-09-11 04:55:38",
          "17.91"
        ],
        [
          "2024-09-11 04:59:50",
          "19.99"
        ],
        [
          "2024-09-11 05:04:50",
          "19.81"
        ],
        [
          "2024-09-11 05:10:13",
          "18.08"
        ],
        [
          "2024-09-11 05:14:50",
          "18.12"
        ],
        [
          "2024-09-11 05:19:50",
          "17.85"
        ],
        [
          "2024-09-11 05:25:37",
          "18.0"
        ],
        [
          "2024-09-11 05:29:50",
          "15.74"
        ],
        [
          "2024-09-11 05:35:38",
          "16.07"
        ],
        [
          "2024-09-11 05:40:14",
          "17.67"
        ],
        [
          "2024-09-11 05:44:50",
          "23.78"
        ],
        [
          "2024-09-11 05:49:50",
          "23.45"
        ],
        [
          "2024-09-11 05:54:50",
          "23.86"
        ],
        [
          "2024-09-11 05:59:50",
          "24.08"
        ],
        [
          "2024-09-11 06:05:38",
          "18.59"
        ],
        [
          "2024-09-11 06:09:50",
          "19.23"
        ],
        [
          "2024-09-11 06:14:50",
          "18.45"
        ],
        [
          "2024-09-11 06:20:37",
          "22.15"
        ],
        [
          "2024-09-11 06:24:50",
          "21.66"
        ],
        [
          "2024-09-11 06:30:27",
          "22.23"
        ],
        [
          "2024-09-11 06:35:36",
          "29.72"
        ],
        [
          "2024-09-11 06:40:27",
          "30.15"
        ],
        [
          "2024-09-11 06:44:50",
          "30.56"
        ],
        [
          "2024-09-11 06:49:50",
          "31.39"
        ],
        [
          "2024-09-11 06:55:38",
          "32.16"
        ],
        [
          "2024-09-11 06:59:50",
          "30.74"
        ],
        [
          "2024-09-11 07:05:23",
          "31.15"
        ],
        [
          "2024-09-11 07:09:50",
          "31.99"
        ],
        [
          "2024-09-11 07:15:38",
          "31.29"
        ],
        [
          "2024-09-11 07:19:50",
          "27.22"
        ],
        [
          "2024-09-11 07:24:50",
          "34.25"
        ],
        [
          "2024-09-11 07:29:50",
          "35.39"
        ],
        [
          "2024-09-11 07:35:36",
          "34.37"
        ],
        [
          "2024-09-11 07:39:50",
          "36.31"
        ],
        [
          "2024-09-11 07:45:38",
          "35.03"
        ],
        [
          "2024-09-11 07:49:50",
          "34.65"
        ],
        [
          "2024-09-11 07:54:50",
          "35.81"
        ],
        [
          "2024-09-11 07:59:50",
          "34.58"
        ],
        [
          "2024-09-11 08:04:50",
          "34.69"
        ],
        [
          "2024-09-11 08:10:48",
          "36.06"
        ],
        [
          "2024-09-11 08:15:38",
          "39.09"
        ],
        [
          "2024-09-11 08:20:14",
          "38.3"
        ],
        [
          "2024-09-11 08:24:50",
          "41.26"
        ],
        [
          "2024-09-11 08:30:27",
          "43.58"
        ],
        [
          "2024-09-11 08:34:50",
          "45.6"
        ],
        [
          "2024-09-11 08:40:37",
          "50.59"
        ],
        [
          "2024-09-11 08:45:38",
          "50.85"
        ],
        [
          "2024-09-11 08:49:50",
          "51.36"
        ],
        [
          "2024-09-11 08:54:50",
          "53.14"
        ],
        [
          "2024-09-11 08:59:50",
          "58.5"
        ],
        [
          "2024-09-11 09:04:50",
          "61.5"
        ],
        [
          "2024-09-11 09:10:50",
          "59.84"
        ],
        [
          "2024-09-11 09:15:38",
          "59.22"
        ],
        [
          "2024-09-11 09:19:50",
          "59.86"
        ],
        [
          "2024-09-11 09:24:50",
          "60.23"
        ],
        [
          "2024-09-11 09:29:50",
          "58.16"
        ],
        [
          "2024-09-11 09:34:50",
          "57.04"
        ],
        [
          "2024-09-11 09:39:50",
          "58.04"
        ],
        [
          "2024-09-11 09:45:38",
          "57.35"
        ],
        [
          "2024-09-11 09:49:50",
          "58.9"
        ],
        [
          "2024-09-11 09:54:50",
          "59.08"
        ],
        [
          "2024-09-11 09:59:50",
          "58.78"
        ],
        [
          "2024-09-11 10:05:14",
          "59.1"
        ]
      ]
      let timeData = [];
      let valueData = []
      for (let i = 0; i < obj.length; i++) {
        timeData.push(obj[i][0])
        valueData.push(obj[i][1])
      }

      let pieOne3 = echarts.init(this.$refs.ech3);
      pieOne3.setOption(
        {
          color: ['#00e6ff', "#ffd503"],
          tooltip: {
            trigger: 'item',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#d2d2d2'
              }
            },
            formatter: function (params) {
              // params 是包含数据信息的对象
              // return '自定义内容：' + params.name + ' - ' + params.value;
              return `${params.value}kW`
            }
          },
          legend: {
            data: ['功率']
          },

          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top: "10%",
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              axisLine: {
                lineStyle: {
                  color: '#d2d2d2' //坐标轴线线的颜色。
                }
              },
              data: timeData
            }
          ],
          yAxis: [
            {
              min: 0,
              max: 100,
              type: 'value',
              axisLine: {
                lineStyle: {
                  color: '#d2d2d2', //坐标轴线线的颜色
                  textStyle: {
                    fontSize: 18, //文字的字体大小
                    fontWeight: '900',
                  }
                }
              },
              axisLabel: {
                margin: 10, //刻度标签与轴线之间的距离
                color: '#d2d2d2',
                textStyle: {
                  fontSize: 12, //文字的字体大小
                  /* fontWeight:'800', */
                }
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: '#57617B' //分隔线颜色设置
                }
              }
            }
          ],
          series: [
            {
              name: '',
              type: 'line',
              smooth: true,
              lineStyle: {
                width: 1
              },
              showSymbol: false,
              areaStyle: {
                opacity: 0.8,
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                  offset: 0,
                  color: '#04626c16'
                },
                {
                  offset: 1,
                  color: '#00a1b3'
                }]),
              },
              emphasis: {
                focus: 'series'
              },
              data: valueData
            },
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieOne3.resize()
      })

      let obj1 = [
        [
          "2024-09-08 00:01:02",
          "477477"
        ],
        [
          "2024-09-08 01:01:02",
          "765458"
        ],
        [
          "2024-09-08 02:01:02",
          "395994"
        ],
        [
          "2024-09-08 03:01:02",
          "458297"
        ],
        [
          "2024-09-08 04:01:02",
          "495843"
        ],
        [
          "2024-09-08 05:01:02",
          "258367"
        ],
        [
          "2024-09-08 06:01:02",
          "445834"
        ],
        [
          "2024-09-08 07:01:02",
          "693629"
        ],
        [
          "2024-09-08 08:01:02",
          "1146770"
        ],
        [
          "2024-09-08 09:01:02",
          "2024407"
        ],
        [
          "2024-09-08 10:01:02",
          "2689632"
        ],
        [
          "2024-09-08 11:01:02",
          "2615917"
        ],
        [
          "2024-09-08 12:01:02",
          "3430453"
        ],
        [
          "2024-09-08 13:01:02",
          "3557647"
        ],
        [
          "2024-09-08 14:01:02",
          "2941539"
        ],
        [
          "2024-09-08 15:01:02",
          "2882473"
        ],
        [
          "2024-09-08 16:01:02",
          "2732711"
        ],
        [
          "2024-09-08 17:01:02",
          "2428192"
        ],
        [
          "2024-09-08 18:01:02",
          "1779179"
        ],
        [
          "2024-09-08 19:01:02",
          "1541013"
        ],
        [
          "2024-09-08 20:01:02",
          "1632339"
        ],
        [
          "2024-09-08 21:01:02",
          "1724897"
        ],
        [
          "2024-09-08 22:01:02",
          "1118368"
        ],
        [
          "2024-09-08 23:01:02",
          "887848"
        ],
        [
          "2024-09-09 00:01:02",
          "1212652"
        ],
        [
          "2024-09-09 01:01:02",
          "702679"
        ],
        [
          "2024-09-09 02:01:02",
          "750228"
        ],
        [
          "2024-09-09 03:01:02",
          "895611"
        ],
        [
          "2024-09-09 04:01:02",
          "720806"
        ],
        [
          "2024-09-09 05:01:02",
          "321292"
        ],
        [
          "2024-09-09 06:01:02",
          "436122"
        ],
        [
          "2024-09-09 07:01:02",
          "1300526"
        ],
        [
          "2024-09-09 08:01:02",
          "2687002"
        ],
        [
          "2024-09-09 09:01:02",
          "4187922"
        ],
        [
          "2024-09-09 10:01:02",
          "4436983"
        ],
        [
          "2024-09-09 11:01:02",
          "4582930"
        ],
        [
          "2024-09-09 12:01:02",
          "4400788"
        ],
        [
          "2024-09-09 13:01:02",
          "3962514"
        ],
        [
          "2024-09-09 14:01:02",
          "3818145"
        ],
        [
          "2024-09-09 15:01:02",
          "4210519"
        ],
        [
          "2024-09-09 16:01:02",
          "4329631"
        ],
        [
          "2024-09-09 17:01:02",
          "4501099"
        ],
        [
          "2024-09-09 18:01:02",
          "3961499"
        ],
        [
          "2024-09-09 19:01:02",
          "2906080"
        ],
        [
          "2024-09-09 20:01:02",
          "2565692"
        ],
        [
          "2024-09-09 21:01:02",
          "2272794"
        ],
        [
          "2024-09-09 22:01:02",
          "1551939"
        ],
        [
          "2024-09-09 23:01:02",
          "1508068"
        ],
        [
          "2024-09-10 00:01:02",
          "888737"
        ],
        [
          "2024-09-10 01:01:02",
          "892604"
        ],
        [
          "2024-09-10 02:01:02",
          "437782"
        ],
        [
          "2024-09-10 03:01:02",
          "256300"
        ],
        [
          "2024-09-10 04:01:02",
          "260182"
        ],
        [
          "2024-09-10 05:01:02",
          "77530"
        ],
        [
          "2024-09-10 06:01:02",
          "256941"
        ],
        [
          "2024-09-10 07:01:02",
          "344201"
        ],
        [
          "2024-09-10 08:01:02",
          "3406639"
        ],
        [
          "2024-09-10 09:01:02",
          "4490572"
        ],
        [
          "2024-09-10 10:01:02",
          "4405256"
        ],
        [
          "2024-09-10 11:01:02",
          "4519349"
        ],
        [
          "2024-09-10 12:01:02",
          "4578526"
        ],
        [
          "2024-09-10 13:01:02",
          "4246528"
        ],
        [
          "2024-09-10 14:01:02",
          "4088565"
        ],
        [
          "2024-09-10 15:01:02",
          "4138536"
        ],
        [
          "2024-09-10 16:01:02",
          "4215061"
        ],
        [
          "2024-09-10 17:01:02",
          "3924348"
        ],
        [
          "2024-09-10 18:01:02",
          "3273639"
        ],
        [
          "2024-09-10 19:01:02",
          "2524696"
        ],
        [
          "2024-09-10 20:01:02",
          "2232987"
        ],
        [
          "2024-09-10 21:01:02",
          "1952122"
        ],
        [
          "2024-09-10 22:01:02",
          "1559646"
        ],
        [
          "2024-09-10 23:01:02",
          "1236853"
        ]
      ]
      let timeData1 = [];
      let valueData1 = []
      for (let i = 0; i < obj1.length; i++) {
        timeData1.push(obj1[i][0])
        valueData1.push(obj1[i][1])
      }
      let pieOne4 = echarts.init(this.$refs.ech4);
      pieOne4.setOption(
        {
          color: ['#00e6ff', "#ffd503"],
          tooltip: {
            trigger: 'item',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#d2d2d2'
              }
            },
            formatter: function (params) {
              // params 是包含数据信息的对象
              // return '自定义内容：' + params.name + ' - ' + params.value;
              return `${params.value}kW`
            }
          },
          legend: {
            data: ['功率']
          },

          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top: "10%",
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              axisLine: {
                lineStyle: {
                  color: '#d2d2d2' //坐标轴线线的颜色。
                }
              },
              data: timeData1
            }
          ],
          yAxis: [
            {

              type: 'value',
              axisLine: {
                lineStyle: {
                  color: '#d2d2d2', //坐标轴线线的颜色
                  textStyle: {
                    fontSize: 18, //文字的字体大小
                    fontWeight: '900',
                  }
                }
              },
              axisLabel: {
                margin: 10, //刻度标签与轴线之间的距离
                color: '#d2d2d2',
                textStyle: {
                  fontSize: 12, //文字的字体大小
                  /* fontWeight:'800', */
                }
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: '#57617B' //分隔线颜色设置
                }
              }
            }
          ],
          series: [
            {
              name: '',
              type: 'line',
              smooth: true,
              lineStyle: {
                width: 1
              },
              showSymbol: false,
              areaStyle: {
                opacity: 0.8,
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                  offset: 0,
                  color: '#04626c16'
                },
                {
                  offset: 1,
                  color: '#00a1b3'
                }]),
              },
              emphasis: {
                focus: 'series'
              },
              data: valueData1
            },
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieOne4.resize()
      })

      /* let pieOne5 = echarts.init(this.$refs.ech5);
      pieOne5.setOption(
        {
          color: ["#FEDA66", "#FDA4A5", "#F99EE4", "#78CDF2", "#26EAB1"],
          grid: {
            top: '5%',
            left: '3%', //grid 组件离容器左侧的距离。
            right: '4%', //grid 组件离容器右侧的距离。
            bottom: '0%', //grid 组件离容器下侧的距离。
            containLabel: true //grid 区域是否包含坐标轴的刻度标签[ default: false ] 
          },
          title: {
            text: '',
            top: 'middle',
            left: 'center',
            textStyle: {
              color: '#FEDA66',
              fontSize: 15
            }
          },
          tooltip: {
            trigger: 'item',
            formatter: function (params) {
              // params 是包含数据信息的对象
              // return '自定义内容：' + params.name + ' - ' + params.value;
              if (params.id == 0) {
                return ""
              } else {
                return `${params.value}kW`
              }
            }
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            show: false
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['40%', '70%'],
              avoidLabelOverlap: false,
              data: [
                { value: 10, name: 'F1' },
                { value: 30, name: 'F2' },
                { value: 20, name: 'F3' },
                { value: 20, name: 'F4' },
                { value: 20, name: `F5` }
              ],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
              labelLine: {
                normal: {
                  show: true,
                  minLength: 0, // 设置最小长度，0表示始终显示
                  length: 5,   // 指引线长度
                  length2: 10,  // 第二条指引线长度，长度为从内半径到此处的线长
                  smooth: 0.2,  // 指引线平滑度
                  lineStyle: {
                    // 指引线样式
                    width: 1,
                    type: 'solid'
                  }
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieOne5.resize()
      }) */

      let pieOne6 = echarts.init(this.$refs.ech6);
      pieOne6.setOption(
        {
          color: ["#2B52E1"],
          grid: {
            top: '15%',
            left: '1%', //grid 组件离容器左侧的距离。
            right: '4%', //grid 组件离容器右侧的距离。
            bottom: '3%', //grid 组件离容器下侧的距离。
            containLabel: true //grid 区域是否包含坐标轴的刻度标签[ default: false ] 
          },
          tooltip: {
            trigger: 'item',
            formatter: function (params) {
              // params 是包含数据信息的对象
              // return '自定义内容：' + params.name + ' - ' + params.value;
              return `${params.value}kg/㎡/天`
            }
          },
          xAxis: {
            type: 'category',
            data: ['三层', '二层', '一层', 'B1', 'B2'],
            axisLine: {
              lineStyle: {
                color: '#d2d2d2' //坐标轴线线的颜色。
              }
            },
          },
          yAxis: [{
            type: 'value', //坐标轴类型。'value' 数值轴，适用于连续数据;'category' 类目轴，适用于离散的类目数据，为该类型时必须通过 data 设置类目数据;'time' 时间轴;'log' 对数轴.
            name: '', //坐标轴名称。
            axisTick: {
              show: false //是否显示坐标轴刻度
            },
            axisLine: {
              lineStyle: {
                show: false,
                color: '#d2d2d2', //坐标轴线线的颜色
                textStyle: {
                  fontSize: 18, //文字的字体大小
                  fontWeight: '900',
                }
              }
            },
            axisLabel: {
              show: true,
              margin: 10, //刻度标签与轴线之间的距离
              color: '#d2d2d2',
              textStyle: {
                fontSize: 12, //文字的字体大小
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#143592' //分隔线颜色设置
              }
            }
          }],
          series: [
            {
              data: [257, 462, 384, 687, 109],
              type: 'bar',
              barWidth: '40%', // 设置为类目宽度的50%
              label: {
                show: true, // 显示数据
                position: 'top', // 数据显示在柱状图上方
                textStyle: { color: '#D2D2D2' }
              },
              itemStyle: { // 使用方法一的写法
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#3CA8E0' },
                  { offset: 1, color: '#3ca9e000' }
                ])
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieOne6.resize()
      })

      let pieOne7 = echarts.init(this.$refs.ech7);
      pieOne7.setOption(
        {
          color: ["#FEDA66", "#FDA4A5", "#F99EE4", "#78CDF2", "#26EAB1", '#a4a5fd'],
          grid: {
            top: '5%',
            left: '3%', //grid 组件离容器左侧的距离。
            right: '4%', //grid 组件离容器右侧的距离。
            bottom: '0%', //grid 组件离容器下侧的距离。
            containLabel: true //grid 区域是否包含坐标轴的刻度标签[ default: false ] 
          },
          title: {
            text: '',
            top: 'middle',
            left: 'center',
            textStyle: {
              color: '#FEDA66',
              fontSize: 15
            }
          },
          tooltip: {
            trigger: 'item',
            formatter: function (params) {
              // params 是包含数据信息的对象
              // return '自定义内容：' + params.name + ' - ' + params.value;
              if (params.id == 0) {
                return ""
              } else {
                return `${params.value}kW`
              }
            }
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            show: false
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['30%', '70%'],
              avoidLabelOverlap: false,
              data: [
                { value: 257, name: '三层' },
                { value: 462, name: '二层' },
                { value: 384, name: '一层' },
                { value: 687, name: 'B1' },
                { value: 109, name: `B2` },
              ],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
              labelLine: {
                normal: {
                  show: true,
                  minLength: 0, // 设置最小长度，0表示始终显示
                  length: 5,   // 指引线长度
                  length2: 10,  // 第二条指引线长度，长度为从内半径到此处的线长
                  smooth: 0.2,  // 指引线平滑度
                  lineStyle: {
                    // 指引线样式
                    width: 1,
                    type: 'solid'
                  }
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieOne7.resize()
      })

      let qiu1 = echarts.init(this.$refs.qiu1);
      qiu1.setOption(
        {
          title: {
            text: this.tempData,
            textStyle: {
              fontSize: 20,
              fontWeight: 'normal',
              color: 'rgb(124,190,255)'
            },
            x: 'center',
            y: 'center'
          },
          graphic: [{
            type: 'group',
            left: 'center',
            top: '80%',
            children: [{
              type: 'text',
              style: {
                fill: '#fff',
                text: '温度',
                fontSize: 20
              }
            }]
          }],
          series: [{
            type: 'liquidFill',
            waveAnimation: 5,
            color: ["rgb(77,95,202)", "rgba(79,71,183,.8)"],
            amplitude: 10,
            radius: '60%',
            center: ['50%', '45%'],
            data: [this.tempValue / 100],
            backgroundStyle: {
              color: {
                type: 'radial',
                x: 0.5,
                y: 0.5,
                r: 0.55,
                colorStops: [{
                  offset: 0.5,
                  color: 'rgb(11,27,52)' // 0% 处的颜色
                }, {
                  offset: 0.75,
                  color: 'rgb(27,41,83)' // 100% 处的颜色
                }, {
                  offset: 0.95,
                  color: 'rgb(53,63,135)' // 100% 处的颜色
                }],
                globalCoord: false // 缺省为 false
              }
            },
            outline: {
              show: false
            },
            label: {
              normal: {
                formatter: ""
              }
            }
          }]
        }
      )
      window.addEventListener('resize', () => {
        qiu1.resize()
      })

      let qiu2 = echarts.init(this.$refs.qiu2);
      qiu2.setOption(
        {
          title: {
            text: this.humdData,
            textStyle: {
              fontSize: 20,
              fontWeight: 'normal',
              color: 'rgb(124,190,255)'
            },
            x: 'center',
            y: 'center'
          },
          graphic: [{
            type: 'group',
            left: 'center',
            top: '80%',
            children: [{
              type: 'text',
              style: {
                fill: '#fff',
                text: '湿度',
                fontSize: 20
              }
            }]
          }],
          series: [{
            type: 'liquidFill',
            waveAnimation: 5,
            color: ["rgb(77,95,202)", "rgba(79,71,183,.8)"],
            amplitude: 10,
            radius: '60%',
            center: ['50%', '45%'],
            data: [this.humdValue / 100],
            backgroundStyle: {
              color: {
                type: 'radial',
                x: 0.5,
                y: 0.5,
                r: 0.55,
                colorStops: [{
                  offset: 0.5,
                  color: 'rgb(11,27,52)' // 0% 处的颜色
                }, {
                  offset: 0.75,
                  color: 'rgb(27,41,83)' // 100% 处的颜色
                }, {
                  offset: 0.95,
                  color: 'rgb(53,63,135)' // 100% 处的颜色
                }],
                globalCoord: false // 缺省为 false
              }
            },
            outline: {
              show: false
            },
            label: {
              normal: {
                formatter: ""
              }
            }
          }]
        }
      )
      window.addEventListener('resize', () => {
        qiu2.resize()
      })

      let qiu3 = echarts.init(this.$refs.qiu3);
      qiu3.setOption(
        {
          title: {
            text: this.co2Data,
            textStyle: {
              fontSize: 20,
              fontWeight: 'normal',
              color: 'rgb(124,190,255)'
            },
            x: 'center',
            y: 'center'
          },
          graphic: [{
            type: 'group',
            left: 'center',
            top: '80%',
            children: [{
              type: 'text',
              style: {
                fill: '#fff',
                text: 'CO2',
                fontSize: 20
              }
            }]
          }],
          series: [{
            type: 'liquidFill',
            waveAnimation: 5,
            color: ["rgb(77,95,202)", "rgba(79,71,183,.8)"],
            amplitude: 10,
            radius: '60%',
            center: ['50%', '45%'],
            data: [this.co2Value / 100],
            backgroundStyle: {
              color: {
                type: 'radial',
                x: 0.5,
                y: 0.5,
                r: 0.55,
                colorStops: [{
                  offset: 0.5,
                  color: 'rgb(11,27,52)' // 0% 处的颜色
                }, {
                  offset: 0.75,
                  color: 'rgb(27,41,83)' // 100% 处的颜色
                }, {
                  offset: 0.95,
                  color: 'rgb(53,63,135)' // 100% 处的颜色
                }],
                globalCoord: false // 缺省为 false
              }
            },
            outline: {
              show: false
            },
            label: {
              normal: {
                formatter: ""
              }
            }
          }]
        }
      )
      window.addEventListener('resize', () => {
        qiu3.resize()
      })

      let qiu4 = echarts.init(this.$refs.qiu4);
      qiu4.setOption(
        {
          title: {
            text: this.vocData,
            textStyle: {
              fontSize: 20,
              fontWeight: 'normal',
              color: 'rgb(124,190,255)'
            },
            x: 'center',
            y: 'center'
          },
          graphic: [{
            type: 'group',
            left: 'center',
            top: '80%',
            children: [{
              type: 'text',
              style: {
                fill: '#fff',
                text: 'VOC',
                fontSize: 20
              }
            }]
          }],
          series: [{
            type: 'liquidFill',
            waveAnimation: 5,
            color: ["rgb(77,95,202)", "rgba(79,71,183,.8)"],
            amplitude: 10,
            radius: '60%',
            center: ['50%', '45%'],
            data: [this.vocValue / 100],
            backgroundStyle: {
              color: {
                type: 'radial',
                x: 0.5,
                y: 0.5,
                r: 0.55,
                colorStops: [{
                  offset: 0.5,
                  color: 'rgb(11,27,52)' // 0% 处的颜色
                }, {
                  offset: 0.75,
                  color: 'rgb(27,41,83)' // 100% 处的颜色
                }, {
                  offset: 0.95,
                  color: 'rgb(53,63,135)' // 100% 处的颜色
                }],
                globalCoord: false // 缺省为 false
              }
            },
            outline: {
              show: false
            },
            label: {
              normal: {
                formatter: ""
              }
            }
          }]
        }
      )
      window.addEventListener('resize', () => {
        qiu4.resize()
      })

      let dLine = echarts.init(this.$refs.dLine);
      dLine.setOption(
        {
          tooltip: {},
          visualMap: {
            max: 50,
            inRange: {
              color: [
                '#313695',
                '#4575b4',
                '#74add1',
                '#abd9e9',
                '#e0f3f8',
                '#ffffbf',
                '#fee090',
                '#fdae61',
                '#f46d43',
                '#d73027',
                '#a50026'
              ]
            }
          },
          xAxis3D: {
            type: 'category',
            data: this.hours,
            axisLabel: {
              color: '#ffffff' // 设置x轴文字颜色为红色
            }
          },
          yAxis3D: {
            type: 'category',
            data: this.days,
            axisLabel: {
              color: '#ffffff' // 设置x轴文字颜色为红色
            }
          },
          zAxis3D: {
            type: 'value',
            axisLabel: {
              color: '#ffffff' // 设置x轴文字颜色为红色
            }
          },
          grid: {
            top: '-10%'
          },
          grid3D: {
            boxWidth: 230,
            boxDepth: 100,
            top: '-10%',
            viewControl: {
              // 调整 beta 值来改变倾斜角度
              beta: 0,
              alpha: 35,
            },
            light: {
              main: {
                intensity: 1.2
              },
              ambient: {
                intensity: 0.3
              }
            }
          },
          series: [
            {
              type: 'bar3D',
              /*  data: this.data1.map(function (item) {
                 debugger
                 return {
                   value: item.value
                 };
               }), */
              data: [
                {
                  value: ['三层', 0, 27.90],
                  name: '门厅'
                },
                {
                  value: ['三层', 1, 22.54],
                  name: '接待室'
                }, {
                  value: ['三层', 2, 24.70],
                  name: '茶室'
                }, {
                  value: ['三层', 3, 26.70],
                  name: '卧室1'
                }, {
                  value: ['三层', 4, 25.00],
                  name: '卧室2'
                },
                {
                  value: ['二层', 0, 17.72],
                  name: '门厅'
                },
                {
                  value: ['二层', 1, 19.45],
                  name: '办公区'
                }, {
                  value: ['二层', 2, 26.90],
                  name: '楼梯间'
                }, {
                  value: ['二层', 3, 23.00],
                  name: '包间'
                }, {
                  value: ['二层', 4, 23.40],
                  name: '经理办公室'
                }, {
                  value: ['二层', 5, 21.80],
                  name: '会议室'
                }, {
                  value: ['二层', 6, 25.00],
                  name: '休息区'
                },
                {
                  value: ['一层', 0, 19.81],
                  name: '门厅'
                },
                {
                  value: ['一层', 1, 24.41],
                  name: '办公室'
                }, {
                  value: ['一层', 2, 24.30],
                  name: '展厅'
                }, {
                  value: ['一层', 3, 25.20],
                  name: '等候区'
                }, {
                  value: ['一层', 4, 24.16],
                  name: '会议室'
                },
                {
                  value: ['B1层', 0, 24.03],
                  name: '宿舍2,5'
                },
                {
                  value: ['B1层', 1, 24.14],
                  name: '宿舍3,6'
                }, {
                  value: ['B1层', 2, 24.27],
                  name: '宿舍1,4'
                }, {
                  value: ['B1层', 3, 19.72],
                  name: '厨房'
                }, {
                  value: ['B1层', 4, 23.89],
                  name: '包间'
                }, {
                  value: ['B1层', 5, 17.63],
                  name: '过道'
                }, {
                  value: ['B1层', 6, 24.88],
                  name: '茶室'
                }, {
                  value: ['B2层', 0, 24.22],
                  name: '健身房'
                },
                {
                  value: ['B2层', 1, 23.50],
                  name: '影音室'
                }, {
                  value: ['B2层', 2, 22.36],
                  name: '红酒区'
                }
              ],
              shading: 'color',
              label: {
                show: true,
                position: 'inside',
                formatter: '{b}',
                color: '#000000'
              },
              itemStyle: {
                opacity: 0.4
              },
              emphasis: {
                label: {
                  fontSize: 20,
                  color: '#fff'
                },
                itemStyle: {
                  color: '#fff'
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        dLine.resize()
      })
    },
    // 获取时间
    getTime() {
      // 获取系统时间
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hour = date.getHours();
      let minute = date.getMinutes();
      let second = date.getSeconds();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      hour = hour < 10 ? "0" + hour : hour;
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;
      let timer = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
      this.homeTime = timer
    },
    // 和风天气数据接口 cb8885d03abc4412ab83212e87a4fddf
    hefeng() {
      return new Promise((resovle, reject) => {
        $.ajax({
          type: 'GET',
          url: 'https://devapi.qweather.com/v7/weather/now?location=101010100&key=cb8885d03abc4412ab83212e87a4fddf',
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          success: (data) => {
            this.temp = data.now.temp
            this.weather = data.now.text
          },
          erroe: (err) => {
            console.log(err)
          }
        })
      })
    },
    // 重新加载水球图
    loadQiu() {
      let qiu1 = echarts.init(this.$refs.qiu1);
      qiu1.setOption(
        {
          title: {
            text: this.tempData,
            textStyle: {
              fontSize: 20,
              fontWeight: 'normal',
              color: 'rgb(124,190,255)'
            },
            x: 'center',
            y: 'center'
          },
          graphic: [{
            type: 'group',
            left: 'center',
            top: '80%',
            children: [{
              type: 'text',
              style: {
                fill: '#fff',
                text: '温度',
                fontSize: 20
              }
            }]
          }],
          series: [{
            type: 'liquidFill',
            waveAnimation: 5,
            color: ["rgb(77,95,202)", "rgba(79,71,183,.8)"],
            amplitude: 10,
            radius: '60%',
            center: ['50%', '45%'],
            data: [this.tempValue / 100],
            backgroundStyle: {
              color: {
                type: 'radial',
                x: 0.5,
                y: 0.5,
                r: 0.55,
                colorStops: [{
                  offset: 0.5,
                  color: 'rgb(11,27,52)' // 0% 处的颜色
                }, {
                  offset: 0.75,
                  color: 'rgb(27,41,83)' // 100% 处的颜色
                }, {
                  offset: 0.95,
                  color: 'rgb(53,63,135)' // 100% 处的颜色
                }],
                globalCoord: false // 缺省为 false
              }
            },
            outline: {
              show: false
            },
            label: {
              normal: {
                formatter: ""
              }
            }
          }]
        }
      )
      window.addEventListener('resize', () => {
        qiu1.resize()
      })

      let qiu2 = echarts.init(this.$refs.qiu2);
      qiu2.setOption(
        {
          title: {
            text: this.humdData,
            textStyle: {
              fontSize: 20,
              fontWeight: 'normal',
              color: 'rgb(124,190,255)'
            },
            x: 'center',
            y: 'center'
          },
          graphic: [{
            type: 'group',
            left: 'center',
            top: '80%',
            children: [{
              type: 'text',
              style: {
                fill: '#fff',
                text: '湿度',
                fontSize: 20
              }
            }]
          }],
          series: [{
            type: 'liquidFill',
            waveAnimation: 5,
            color: ["rgb(77,95,202)", "rgba(79,71,183,.8)"],
            amplitude: 10,
            radius: '60%',
            center: ['50%', '45%'],
            data: [this.humdValue / 100],
            backgroundStyle: {
              color: {
                type: 'radial',
                x: 0.5,
                y: 0.5,
                r: 0.55,
                colorStops: [{
                  offset: 0.5,
                  color: 'rgb(11,27,52)' // 0% 处的颜色
                }, {
                  offset: 0.75,
                  color: 'rgb(27,41,83)' // 100% 处的颜色
                }, {
                  offset: 0.95,
                  color: 'rgb(53,63,135)' // 100% 处的颜色
                }],
                globalCoord: false // 缺省为 false
              }
            },
            outline: {
              show: false
            },
            label: {
              normal: {
                formatter: ""
              }
            }
          }]
        }
      )
      window.addEventListener('resize', () => {
        qiu2.resize()
      })

      let qiu3 = echarts.init(this.$refs.qiu3);
      qiu3.setOption(
        {
          title: {
            text: this.co2Data,
            textStyle: {
              fontSize: 20,
              fontWeight: 'normal',
              color: 'rgb(124,190,255)'
            },
            x: 'center',
            y: 'center'
          },
          graphic: [{
            type: 'group',
            left: 'center',
            top: '80%',
            children: [{
              type: 'text',
              style: {
                fill: '#fff',
                text: 'CO2',
                fontSize: 20
              }
            }]
          }],
          series: [{
            type: 'liquidFill',
            waveAnimation: 5,
            color: ["rgb(77,95,202)", "rgba(79,71,183,.8)"],
            amplitude: 10,
            radius: '60%',
            center: ['50%', '45%'],
            data: [this.co2Value / 100],
            backgroundStyle: {
              color: {
                type: 'radial',
                x: 0.5,
                y: 0.5,
                r: 0.55,
                colorStops: [{
                  offset: 0.5,
                  color: 'rgb(11,27,52)' // 0% 处的颜色
                }, {
                  offset: 0.75,
                  color: 'rgb(27,41,83)' // 100% 处的颜色
                }, {
                  offset: 0.95,
                  color: 'rgb(53,63,135)' // 100% 处的颜色
                }],
                globalCoord: false // 缺省为 false
              }
            },
            outline: {
              show: false
            },
            label: {
              normal: {
                formatter: ""
              }
            }
          }]
        }
      )
      window.addEventListener('resize', () => {
        qiu3.resize()
      })

      let qiu4 = echarts.init(this.$refs.qiu4);
      qiu4.setOption(
        {
          title: {
            text: this.vocData,
            textStyle: {
              fontSize: 20,
              fontWeight: 'normal',
              color: 'rgb(124,190,255)'
            },
            x: 'center',
            y: 'center'
          },
          graphic: [{
            type: 'group',
            left: 'center',
            top: '80%',
            children: [{
              type: 'text',
              style: {
                fill: '#fff',
                text: 'VOC',
                fontSize: 20
              }
            }]
          }],
          series: [{
            type: 'liquidFill',
            waveAnimation: 5,
            color: ["rgb(77,95,202)", "rgba(79,71,183,.8)"],
            amplitude: 10,
            radius: '60%',
            center: ['50%', '45%'],
            data: [this.vocValue / 100],
            backgroundStyle: {
              color: {
                type: 'radial',
                x: 0.5,
                y: 0.5,
                r: 0.55,
                colorStops: [{
                  offset: 0.5,
                  color: 'rgb(11,27,52)' // 0% 处的颜色
                }, {
                  offset: 0.75,
                  color: 'rgb(27,41,83)' // 100% 处的颜色
                }, {
                  offset: 0.95,
                  color: 'rgb(53,63,135)' // 100% 处的颜色
                }],
                globalCoord: false // 缺省为 false
              }
            },
            outline: {
              show: false
            },
            label: {
              normal: {
                formatter: ""
              }
            }
          }]
        }
      )
      window.addEventListener('resize', () => {
        qiu4.resize()
      })
    },
    // 点击事件
    onclickEcharts(item) {
      if (item.name == 'B2') {
        this.tempData = "25.51℃",
          this.humdData = '64.62%',
          this.vocData = "378ppm",
          this.co2Data = "548ppm"
        this.tempValue = 25,
          this.humdValue = 64,
          this.vocValue = 37,
          this.co2Value = 54
        this.loadQiu()
      }
      if (item.name == 'B1') {
        this.tempData = "23.95℃",
          this.humdData = '70.96%',
          this.vocData = "542ppm",
          this.co2Data = "756ppm"
        this.tempValue = 23,
          this.humdValue = 70,
          this.vocValue = 54,
          this.co2Value = 75
        this.loadQiu()
      }
      if (item.name == '一层') {
        this.tempData = "24.52℃",
          this.humdData = '56.29%',
          this.vocData = "136ppm",
          this.co2Data = "400ppm"
        this.tempValue = 24.52,
          this.humdValue = 56.29,
          this.vocValue = 13,
          this.co2Value = 40
        this.loadQiu()
      }
      if (item.name == '二层') {
        this.tempData = "24.72℃",
          this.humdData = '67.61%',
          this.vocData = "470ppm",
          this.co2Data = "615ppm"
        this.tempValue = 24.72,
          this.humdValue = 67.61,
          this.vocValue = 47,
          this.co2Value = 65
        this.loadQiu()
      }
      if (item.name == '三层') {
        this.tempData = "26.94℃",
          this.humdData = '59.73%',
          this.vocData = "689ppm",
          this.co2Data = "768ppm"
        this.tempValue = 26.94,
          this.humdValue = 60,
          this.vocValue = 69,
          this.co2Value = 76
        this.loadQiu()
      }
    }
  },

  watch: {}

}

</script>
<style lang='scss' scoped>
.fish-content {
  width: 100%;
  height: 100%;
  /* background: radial-gradient(ellipse at bottom, #323e72 0%, #120F44 100%); */
  background-image: url('../../../static/img/fisheries/bg.png');
  background-size: 100% 100%;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
}

.fish-header {
  width: 100%;
  height: 60px;
  box-sizing: border-box;
  padding: 10px 20px 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  font-size: 2vh;
  font-weight: 800;
}

.fish-body {
  width: 100%;
  height: calc(100% - 60px);
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0px 10px 10px 10px;
  align-items: center;
  flex-wrap: wrap;
  overflow: hidden;

  .fish-body-left {
    width: 60%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    .fish-body-left-box1 {
      width: 100%;
      height: 98%;
      background: rgba(12, 5, 38, 0.35);
      box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
      backdrop-filter: blur(6.5px);
      -webkit-backdrop-filter: blur(6.5px);
      border-radius: 5px;
      border: 1px solid rgba(255, 255, 255, 0.18);
      box-sizing: border-box;
      padding: 10px 10px;
      /* 简单定位 */
      position: relative;
      /* 显示层级最上面 */
      z-index: 0;
      /* 超出部分要隐藏 */
      overflow: hidden;

      .le-box1 {
        width: 100%;
        height: 27%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .qiu-box {
          width: 23%;
          height: 100%;
        }
      }

      .le-box2 {
        width: 100%;
        height: 70%;
      }
    }

    .fish-body-left-box1::before {
      content: "";
      /* 宽高要超过父级默认的大小 */
      width: 200%;
      height: 200%;
      /* 基础背景颜色 */
      background: #050f3f62;
      /* conic-gradient 围绕中心点旋转的渐变 */
      background-image: conic-gradient(transparent, #53e0ff, transparent 30%);
      /* 定位到中间 */
      position: absolute;
      left: -50%;
      top: -50%;
      /* 显示层级最底层 */
      z-index: -2;

      /* 旋转整个灯光渐变这一层 */
      animation: rotate 5s linear infinite;
    }

    .fish-body-left-box1::after {
      content: "";
      /* 往内撑开盒子宽高，正好小一圈当做边框 */
      inset: 1vmin;
      background: radial-gradient(ellipse at bottom, #0b1548 0%, #050E3B 100%);
      border-radius: 1vmin;
      position: absolute;
      /* 显示层级中间，盖住最后一层的灯光 */
      z-index: -1;
    }
  }

  .fish-body-right {
    width: 39%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    .fish-body-right-box {
      width: 100%;
      height: 23%;
      display: flex;
      box-sizing: border-box;
      padding: 10px 10px;
      background: rgba(12, 5, 38, 0.35);
      box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
      backdrop-filter: blur(6.5px);
      -webkit-backdrop-filter: blur(6.5px);
      border-radius: 5px;
      border: 1px solid rgba(255, 255, 255, 0.18);

      .right-box-le {
        width: 60%;
        height: 100%;
      }

      .right-box-ri {
        width: 38%;
        height: 100%;
      }
    }
  }
}

.right-box-title {
  width: 100%;
  font-size: 1.7vh;
  color: #d2d2d2;
  font-weight: 800;
  margin-left: 2%;
}

.line {
  width: 2px;
  height: 100%;
  background-color: #454760;
}

.ech-box {
  width: 100%;
  height: 85%;
}

.ling-box {
  width: 1vh;
  height: 1vh;
  margin-right: 2%;
  border-radius: 2px;
  transform: rotate(45deg);
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

#stars {
  width: 1px;
  height: 1px;
  background: transparent;
  box-shadow: 1407px 511px #FFF, 1611px 119px #FFF, 1686px 956px #FFF, 1163px 1929px #FFF, 912px 1242px #FFF, 490px 469px #FFF, 869px 425px #FFF, 1447px 891px #FFF, 422px 1960px #FFF, 517px 1995px #FFF, 738px 171px #FFF, 1328px 1668px #FFF, 874px 1490px #FFF, 83px 81px #FFF, 632px 98px #FFF, 1518px 1764px #FFF, 636px 596px #FFF, 1178px 131px #FFF, 278px 1179px #FFF, 1898px 1951px #FFF, 1787px 326px #FFF, 186px 1588px #FFF, 552px 1942px #FFF, 1929px 1300px #FFF, 802px 681px #FFF, 430px 1711px #FFF, 1192px 308px #FFF, 123px 1604px #FFF, 880px 169px #FFF, 1400px 632px #FFF, 500px 1165px #FFF, 288px 1208px #FFF, 319px 1419px #FFF, 1170px 980px #FFF, 1608px 784px #FFF, 1735px 1276px #FFF, 966px 1534px #FFF, 654px 783px #FFF, 1366px 964px #FFF, 1213px 60px #FFF, 302px 1509px #FFF, 845px 714px #FFF, 524px 323px #FFF, 1538px 1399px #FFF, 394px 619px #FFF, 680px 26px #FFF, 353px 776px #FFF, 1826px 1450px #FFF, 1909px 1452px #FFF, 1014px 1315px #FFF, 1883px 1474px #FFF, 766px 1742px #FFF, 1693px 658px #FFF, 1186px 302px #FFF, 376px 1575px #FFF, 712px 1739px #FFF, 1627px 299px #FFF, 482px 224px #FFF, 1379px 510px #FFF, 1543px 1602px #FFF, 45px 606px #FFF, 827px 1336px #FFF, 224px 1939px #FFF, 1098px 1342px #FFF, 813px 1553px #FFF, 825px 419px #FFF, 519px 894px #FFF, 1406px 797px #FFF, 1341px 274px #FFF, 1787px 903px #FFF, 1701px 1483px #FFF, 1108px 232px #FFF, 1599px 1409px #FFF, 659px 870px #FFF, 1538px 335px #FFF, 632px 1855px #FFF, 154px 1026px #FFF, 1722px 979px #FFF, 1339px 509px #FFF, 1833px 460px #FFF, 315px 65px #FFF, 496px 1927px #FFF, 1314px 427px #FFF, 344px 1046px #FFF, 1658px 724px #FFF, 1899px 264px #FFF, 1200px 1305px #FFF, 1562px 339px #FFF, 159px 766px #FFF, 1639px 1966px #FFF, 459px 1898px #FFF, 944px 763px #FFF, 1174px 1056px #FFF, 1825px 790px #FFF, 906px 1526px #FFF, 1537px 1303px #FFF, 79px 1105px #FFF, 1318px 672px #FFF, 1232px 61px #FFF, 709px 1078px #FFF, 1010px 1810px #FFF, 777px 1160px #FFF, 1598px 1428px #FFF, 815px 684px #FFF, 1003px 943px #FFF, 1876px 1003px #FFF, 1025px 1529px #FFF, 66px 549px #FFF, 514px 457px #FFF, 262px 1005px #FFF, 812px 1705px #FFF, 1163px 1087px #FFF, 165px 45px #FFF, 677px 1462px #FFF, 580px 1675px #FFF, 1848px 1384px #FFF, 449px 862px #FFF, 1629px 1979px #FFF, 667px 135px #FFF, 240px 53px #FFF, 1919px 1832px #FFF, 696px 1384px #FFF, 1630px 361px #FFF, 878px 663px #FFF, 1226px 1723px #FFF, 765px 686px #FFF, 576px 1647px #FFF, 97px 1602px #FFF, 1117px 1049px #FFF, 1433px 68px #FFF, 1375px 1991px #FFF, 1755px 990px #FFF, 1483px 801px #FFF, 473px 1802px #FFF, 822px 768px #FFF, 196px 577px #FFF, 516px 504px #FFF, 623px 981px #FFF, 1478px 819px #FFF, 126px 384px #FFF, 584px 1908px #FFF, 1549px 521px #FFF, 1866px 1335px #FFF, 586px 342px #FFF, 1698px 642px #FFF, 136px 188px #FFF, 1613px 520px #FFF, 937px 326px #FFF, 1111px 169px #FFF, 229px 229px #FFF, 1357px 20px #FFF, 725px 1305px #FFF, 23px 1977px #FFF, 426px 1945px #FFF, 1628px 1530px #FFF, 256px 1295px #FFF, 58px 78px #FFF, 409px 1145px #FFF, 1607px 767px #FFF, 212px 144px #FFF, 361px 1890px #FFF, 1827px 1451px #FFF, 1875px 645px #FFF, 571px 853px #FFF, 1302px 301px #FFF, 9px 1344px #FFF, 418px 619px #FFF, 1941px 90px #FFF, 949px 640px #FFF, 179px 1783px #FFF, 1104px 360px #FFF, 1723px 370px #FFF, 1122px 1418px #FFF, 1374px 508px #FFF, 1108px 1089px #FFF, 1440px 1743px #FFF, 462px 1495px #FFF, 1187px 265px #FFF, 567px 74px #FFF, 557px 542px #FFF, 967px 673px #FFF, 825px 1971px #FFF, 988px 1260px #FFF, 710px 1206px #FFF, 538px 1805px #FFF, 137px 861px #FFF, 1922px 1313px #FFF, 481px 470px #FFF, 1224px 316px #FFF, 1979px 239px #FFF, 22px 1155px #FFF, 1640px 186px #FFF, 592px 1709px #FFF, 765px 170px #FFF, 129px 1750px #FFF, 788px 719px #FFF, 181px 1327px #FFF, 433px 1455px #FFF, 141px 450px #FFF, 1287px 1027px #FFF, 1278px 1462px #FFF, 688px 1526px #FFF, 463px 1604px #FFF, 1232px 297px #FFF, 920px 1227px #FFF, 1571px 1765px #FFF, 1482px 1316px #FFF, 759px 1463px #FFF, 950px 1166px #FFF, 1532px 1588px #FFF, 608px 267px #FFF, 1862px 1943px #FFF, 805px 717px #FFF, 1803px 1319px #FFF, 1821px 683px #FFF, 995px 1958px #FFF, 484px 932px #FFF, 366px 901px #FFF, 451px 1563px #FFF, 1704px 1471px #FFF, 1379px 44px #FFF, 1778px 472px #FFF, 419px 1806px #FFF, 1545px 222px #FFF, 1563px 777px #FFF, 39px 964px #FFF, 1620px 24px #FFF, 1151px 320px #FFF, 1940px 1426px #FFF, 1555px 1538px #FFF, 1747px 488px #FFF, 1348px 300px #FFF, 990px 538px #FFF, 780px 361px #FFF, 988px 971px #FFF, 1973px 1534px #FFF, 1542px 1829px #FFF, 1557px 216px #FFF, 1404px 641px #FFF, 47px 877px #FFF, 65px 1738px #FFF, 1895px 1798px #FFF, 56px 591px #FFF, 536px 906px #FFF, 568px 74px #FFF, 433px 462px #FFF, 727px 295px #FFF, 876px 1878px #FFF, 1891px 1946px #FFF, 1451px 493px #FFF, 1569px 226px #FFF, 879px 1351px #FFF, 1529px 43px #FFF, 33px 74px #FFF, 1516px 1924px #FFF, 878px 323px #FFF, 455px 1122px #FFF, 1943px 526px #FFF, 1456px 1060px #FFF, 1631px 979px #FFF, 1819px 1324px #FFF, 1660px 1192px #FFF, 1867px 1714px #FFF, 1928px 1940px #FFF, 1618px 744px #FFF, 979px 357px #FFF, 98px 1645px #FFF, 1898px 1207px #FFF, 1134px 16px #FFF, 1313px 1018px #FFF, 717px 812px #FFF, 1503px 234px #FFF, 1612px 188px #FFF, 29px 459px #FFF, 414px 1487px #FFF, 1223px 1730px #FFF, 1643px 1188px #FFF, 424px 767px #FFF, 1692px 1591px #FFF, 1265px 367px #FFF, 54px 832px #FFF, 410px 804px #FFF, 1397px 1242px #FFF, 549px 1484px #FFF, 721px 1088px #FFF, 472px 1240px #FFF, 1927px 514px #FFF, 1303px 1310px #FFF, 71px 1276px #FFF, 829px 1332px #FFF, 84px 1920px #FFF, 1088px 375px #FFF, 1659px 736px #FFF, 967px 294px #FFF, 651px 92px #FFF, 1572px 143px #FFF, 1680px 770px #FFF, 1873px 1289px #FFF, 1983px 821px #FFF, 448px 1090px #FFF, 890px 1332px #FFF, 836px 867px #FFF, 1867px 1213px #FFF, 1874px 1574px #FFF, 750px 1063px #FFF, 1297px 1971px #FFF, 1274px 1015px #FFF, 1628px 933px #FFF, 309px 1386px #FFF, 299px 1621px #FFF, 1973px 526px #FFF, 196px 1416px #FFF, 778px 715px #FFF, 1993px 1294px #FFF, 381px 435px #FFF, 1405px 681px #FFF, 1759px 1077px #FFF, 1764px 1748px #FFF, 168px 470px #FFF, 978px 781px #FFF, 110px 1666px #FFF, 835px 747px #FFF, 112px 95px #FFF, 604px 712px #FFF, 1121px 1752px #FFF, 393px 1782px #FFF, 1869px 830px #FFF, 1303px 348px #FFF, 427px 1546px #FFF, 761px 718px #FFF, 946px 674px #FFF, 832px 964px #FFF, 1607px 2000px #FFF, 1624px 1296px #FFF, 1093px 735px #FFF, 1865px 608px #FFF, 933px 1278px #FFF, 1402px 547px #FFF, 1865px 1211px #FFF, 109px 72px #FFF, 249px 1482px #FFF, 586px 1933px #FFF, 911px 1336px #FFF, 697px 853px #FFF, 987px 1797px #FFF, 1371px 933px #FFF, 492px 1896px #FFF, 998px 1866px #FFF, 518px 31px #FFF, 1873px 372px #FFF, 1025px 1308px #FFF, 1478px 965px #FFF, 1934px 934px #FFF, 1048px 1262px #FFF, 1839px 40px #FFF, 1399px 732px #FFF, 735px 416px #FFF, 621px 394px #FFF, 788px 1802px #FFF, 1918px 307px #FFF, 432px 1845px #FFF, 616px 481px #FFF, 921px 798px #FFF, 354px 597px #FFF, 1622px 214px #FFF, 1349px 1983px #FFF, 1033px 1622px #FFF, 1198px 407px #FFF, 1239px 1449px #FFF, 1278px 1978px #FFF, 426px 1264px #FFF, 507px 1341px #FFF, 1956px 818px #FFF, 1041px 277px #FFF, 1371px 639px #FFF, 1224px 419px #FFF, 211px 1106px #FFF, 847px 656px #FFF, 534px 1891px #FFF, 1289px 823px #FFF, 906px 482px #FFF, 347px 1837px #FFF, 1246px 1462px #FFF, 915px 1858px #FFF, 559px 1320px #FFF, 77px 1555px #FFF, 845px 1743px #FFF, 313px 1414px #FFF, 188px 252px #FFF, 509px 637px #FFF, 374px 142px #FFF, 1397px 474px #FFF, 458px 1197px #FFF, 292px 619px #FFF, 1749px 14px #FFF, 1638px 24px #FFF, 563px 1752px #FFF, 1940px 1065px #FFF, 1145px 1030px #FFF, 894px 1470px #FFF, 444px 32px #FFF, 1341px 1136px #FFF, 1941px 412px #FFF, 1328px 785px #FFF, 161px 1740px #FFF, 948px 829px #FFF, 933px 823px #FFF, 1709px 507px #FFF, 1366px 1821px #FFF, 720px 731px #FFF, 162px 682px #FFF, 1684px 882px #FFF, 134px 497px #FFF, 1659px 1701px #FFF, 1186px 446px #FFF, 911px 1435px #FFF, 1814px 1028px #FFF, 1234px 1520px #FFF, 1186px 23px #FFF, 318px 87px #FFF, 1179px 837px #FFF, 1071px 46px #FFF, 1125px 1862px #FFF, 94px 261px #FFF, 1574px 282px #FFF, 1039px 815px #FFF, 1776px 1472px #FFF, 867px 473px #FFF, 901px 215px #FFF, 862px 630px #FFF, 1480px 1673px #FFF, 411px 1896px #FFF, 1335px 944px #FFF, 148px 1235px #FFF, 57px 140px #FFF, 447px 651px #FFF, 1414px 1651px #FFF, 209px 1770px #FFF, 1800px 1590px #FFF, 1304px 1px #FFF, 279px 771px #FFF, 1770px 1398px #FFF, 724px 1201px #FFF, 245px 1145px #FFF, 172px 1951px #FFF, 284px 236px #FFF, 1905px 1307px #FFF, 1948px 574px #FFF, 283px 669px #FFF, 247px 384px #FFF, 224px 619px #FFF, 128px 772px #FFF, 1698px 1405px #FFF, 830px 505px #FFF, 1938px 397px #FFF, 1772px 1001px #FFF, 1454px 808px #FFF, 304px 561px #FFF, 1321px 966px #FFF, 735px 1368px #FFF, 894px 345px #FFF, 1217px 1997px #FFF, 892px 1342px #FFF, 353px 379px #FFF, 1382px 1156px #FFF, 164px 1239px #FFF, 1268px 1859px #FFF, 1385px 1721px #FFF, 16px 283px #FFF, 1819px 200px #FFF, 660px 1111px #FFF, 1679px 1728px #FFF, 463px 596px #FFF, 217px 1834px #FFF, 1879px 538px #FFF, 304px 906px #FFF, 1327px 1347px #FFF, 1226px 1579px #FFF, 1786px 1616px #FFF, 1234px 1982px #FFF, 1868px 1862px #FFF, 814px 948px #FFF, 178px 1837px #FFF, 571px 1701px #FFF, 106px 566px #FFF, 270px 925px #FFF, 1417px 248px #FFF, 609px 1551px #FFF, 992px 1825px #FFF, 1515px 1999px #FFF, 1167px 914px #FFF, 1698px 490px #FFF, 189px 1463px #FFF, 928px 612px #FFF, 1714px 803px #FFF, 535px 402px #FFF, 1000px 379px #FFF, 1610px 574px #FFF, 1882px 1155px #FFF, 1425px 1514px #FFF, 417px 1987px #FFF, 1681px 1059px #FFF, 841px 762px #FFF, 1886px 1098px #FFF, 1785px 236px #FFF, 1950px 950px #FFF, 444px 1937px #FFF, 1364px 540px #FFF, 1971px 225px #FFF, 1624px 868px #FFF, 869px 640px #FFF, 1637px 559px #FFF, 20px 823px #FFF, 409px 177px #FFF, 1804px 1626px #FFF, 388px 527px #FFF, 1385px 1734px #FFF, 988px 1310px #FFF, 443px 599px #FFF, 1780px 434px #FFF, 654px 419px #FFF, 268px 1424px #FFF, 1971px 40px #FFF, 360px 1834px #FFF, 875px 1930px #FFF, 1866px 1885px #FFF, 453px 1670px #FFF, 1696px 1337px #FFF, 604px 1887px #FFF, 1405px 769px #FFF, 1546px 897px #FFF, 595px 1975px #FFF, 32px 1765px #FFF, 896px 1150px #FFF, 1818px 95px #FFF, 444px 49px #FFF, 589px 1796px #FFF, 764px 1965px #FFF, 920px 1803px #FFF, 403px 1997px #FFF, 833px 1282px #FFF, 1127px 1770px #FFF, 1810px 77px #FFF, 1214px 1102px #FFF, 364px 401px #FFF, 1139px 1191px #FFF, 916px 1907px #FFF, 870px 290px #FFF, 688px 678px #FFF, 1523px 34px #FFF, 1265px 1082px #FFF, 1394px 1080px #FFF, 1787px 1738px #FFF, 1682px 755px #FFF, 1955px 832px #FFF, 546px 1577px #FFF, 1062px 1561px #FFF, 344px 826px #FFF, 1442px 782px #FFF, 467px 1477px #FFF, 879px 1439px #FFF, 1672px 268px #FFF, 1317px 1355px #FFF, 1980px 1965px #FFF, 688px 1465px #FFF, 1131px 872px #FFF, 1301px 1656px #FFF, 974px 583px #FFF, 1613px 1467px #FFF, 1976px 1995px #FFF, 1377px 760px #FFF, 1367px 387px #FFF, 1880px 191px #FFF, 711px 876px #FFF, 539px 152px #FFF, 545px 1809px #FFF, 920px 970px #FFF, 1154px 1355px #FFF, 1968px 94px #FFF, 1703px 490px #FFF, 380px 146px #FFF, 1561px 785px #FFF, 1930px 1385px #FFF, 519px 1091px #FFF, 269px 570px #FFF, 109px 1326px #FFF, 1476px 969px #FFF, 1999px 1885px #FFF, 341px 1238px #FFF, 1105px 1076px #FFF, 596px 88px #FFF, 937px 492px #FFF, 1339px 1673px #FFF, 1967px 762px #FFF, 65px 952px #FFF, 111px 93px #FFF, 1011px 1684px #FFF, 377px 1430px #FFF, 1011px 386px #FFF, 1162px 421px #FFF, 196px 617px #FFF, 1407px 1141px #FFF, 1562px 572px #FFF, 316px 690px #FFF, 1600px 1980px #FFF, 1545px 1254px #FFF, 680px 1120px #FFF, 575px 1284px #FFF, 179px 1470px #FFF, 1496px 1506px #FFF, 977px 1376px #FFF, 1282px 708px #FFF, 408px 1427px #FFF, 1173px 1597px #FFF, 1120px 1755px #FFF, 974px 520px #FFF, 979px 384px #FFF, 622px 1116px #FFF, 1307px 866px #FFF, 1188px 1596px #FFF, 858px 1947px #FFF, 861px 1373px #FFF, 857px 43px #FFF, 1878px 499px #FFF, 1297px 535px #FFF, 870px 1286px #FFF, 1452px 448px #FFF, 906px 72px #FFF, 1450px 872px #FFF, 1607px 1755px #FFF, 1071px 1959px #FFF, 976px 879px #FFF, 1435px 284px #FFF, 1601px 496px #FFF, 671px 1713px #FFF, 356px 1148px #FFF, 837px 867px #FFF, 246px 858px #FFF, 1031px 1594px #FFF, 571px 214px #FFF, 1012px 1329px #FFF, 1566px 1142px #FFF, 219px 1376px #FFF, 1580px 1454px #FFF, 690px 1037px #FFF, 1940px 756px #FFF, 1755px 850px #FFF, 1037px 363px #FFF, 25px 515px #FFF, 806px 1571px #FFF, 1266px 1398px #FFF, 695px 791px #FFF, 1838px 950px #FFF, 1578px 27px #FFF, 1692px 1581px #FFF, 1817px 1040px #FFF, 1781px 238px #FFF, 1052px 895px #FFF, 398px 440px #FFF, 1643px 325px #FFF, 79px 848px #FFF, 1295px 326px #FFF, 293px 81px #FFF, 1202px 1580px #FFF, 1441px 100px #FFF, 1295px 1465px #FFF, 1132px 1275px #FFF, 774px 704px #FFF, 1109px 1546px #FFF, 557px 1390px #FFF, 1253px 1224px #FFF, 1063px 1618px #FFF, 1793px 440px #FFF, 890px 1988px #FFF, 814px 424px #FFF, 1390px 1280px #FFF, 1127px 907px #FFF, 1044px 1368px #FFF, 1317px 876px #FFF, 762px 638px #FFF, 965px 747px #FFF, 755px 1945px #FFF, 706px 414px #FFF, 1842px 1673px #FFF, 1158px 1336px #FFF, 989px 1955px #FFF, 1857px 89px #FFF, 1659px 343px #FFF, 509px 1385px #FFF, 1620px 758px #FFF, 1958px 1064px #FFF, 178px 341px #FFF, 1500px 808px #FFF, 20px 1646px #FFF, 1572px 870px #FFF, 1821px 1377px #FFF, 328px 1965px #FFF, 903px 616px #FFF, 1731px 1599px #FFF, 267px 856px #FFF;
  animation: animStar 50s linear infinite;
}

#stars:after {
  content: " ";
  position: absolute;
  top: 2000px;
  width: 1px;
  height: 1px;
  background: transparent;
  box-shadow: 1407px 511px #FFF, 1611px 119px #FFF, 1686px 956px #FFF, 1163px 1929px #FFF, 912px 1242px #FFF, 490px 469px #FFF, 869px 425px #FFF, 1447px 891px #FFF, 422px 1960px #FFF, 517px 1995px #FFF, 738px 171px #FFF, 1328px 1668px #FFF, 874px 1490px #FFF, 83px 81px #FFF, 632px 98px #FFF, 1518px 1764px #FFF, 636px 596px #FFF, 1178px 131px #FFF, 278px 1179px #FFF, 1898px 1951px #FFF, 1787px 326px #FFF, 186px 1588px #FFF, 552px 1942px #FFF, 1929px 1300px #FFF, 802px 681px #FFF, 430px 1711px #FFF, 1192px 308px #FFF, 123px 1604px #FFF, 880px 169px #FFF, 1400px 632px #FFF, 500px 1165px #FFF, 288px 1208px #FFF, 319px 1419px #FFF, 1170px 980px #FFF, 1608px 784px #FFF, 1735px 1276px #FFF, 966px 1534px #FFF, 654px 783px #FFF, 1366px 964px #FFF, 1213px 60px #FFF, 302px 1509px #FFF, 845px 714px #FFF, 524px 323px #FFF, 1538px 1399px #FFF, 394px 619px #FFF, 680px 26px #FFF, 353px 776px #FFF, 1826px 1450px #FFF, 1909px 1452px #FFF, 1014px 1315px #FFF, 1883px 1474px #FFF, 766px 1742px #FFF, 1693px 658px #FFF, 1186px 302px #FFF, 376px 1575px #FFF, 712px 1739px #FFF, 1627px 299px #FFF, 482px 224px #FFF, 1379px 510px #FFF, 1543px 1602px #FFF, 45px 606px #FFF, 827px 1336px #FFF, 224px 1939px #FFF, 1098px 1342px #FFF, 813px 1553px #FFF, 825px 419px #FFF, 519px 894px #FFF, 1406px 797px #FFF, 1341px 274px #FFF, 1787px 903px #FFF, 1701px 1483px #FFF, 1108px 232px #FFF, 1599px 1409px #FFF, 659px 870px #FFF, 1538px 335px #FFF, 632px 1855px #FFF, 154px 1026px #FFF, 1722px 979px #FFF, 1339px 509px #FFF, 1833px 460px #FFF, 315px 65px #FFF, 496px 1927px #FFF, 1314px 427px #FFF, 344px 1046px #FFF, 1658px 724px #FFF, 1899px 264px #FFF, 1200px 1305px #FFF, 1562px 339px #FFF, 159px 766px #FFF, 1639px 1966px #FFF, 459px 1898px #FFF, 944px 763px #FFF, 1174px 1056px #FFF, 1825px 790px #FFF, 906px 1526px #FFF, 1537px 1303px #FFF, 79px 1105px #FFF, 1318px 672px #FFF, 1232px 61px #FFF, 709px 1078px #FFF, 1010px 1810px #FFF, 777px 1160px #FFF, 1598px 1428px #FFF, 815px 684px #FFF, 1003px 943px #FFF, 1876px 1003px #FFF, 1025px 1529px #FFF, 66px 549px #FFF, 514px 457px #FFF, 262px 1005px #FFF, 812px 1705px #FFF, 1163px 1087px #FFF, 165px 45px #FFF, 677px 1462px #FFF, 580px 1675px #FFF, 1848px 1384px #FFF, 449px 862px #FFF, 1629px 1979px #FFF, 667px 135px #FFF, 240px 53px #FFF, 1919px 1832px #FFF, 696px 1384px #FFF, 1630px 361px #FFF, 878px 663px #FFF, 1226px 1723px #FFF, 765px 686px #FFF, 576px 1647px #FFF, 97px 1602px #FFF, 1117px 1049px #FFF, 1433px 68px #FFF, 1375px 1991px #FFF, 1755px 990px #FFF, 1483px 801px #FFF, 473px 1802px #FFF, 822px 768px #FFF, 196px 577px #FFF, 516px 504px #FFF, 623px 981px #FFF, 1478px 819px #FFF, 126px 384px #FFF, 584px 1908px #FFF, 1549px 521px #FFF, 1866px 1335px #FFF, 586px 342px #FFF, 1698px 642px #FFF, 136px 188px #FFF, 1613px 520px #FFF, 937px 326px #FFF, 1111px 169px #FFF, 229px 229px #FFF, 1357px 20px #FFF, 725px 1305px #FFF, 23px 1977px #FFF, 426px 1945px #FFF, 1628px 1530px #FFF, 256px 1295px #FFF, 58px 78px #FFF, 409px 1145px #FFF, 1607px 767px #FFF, 212px 144px #FFF, 361px 1890px #FFF, 1827px 1451px #FFF, 1875px 645px #FFF, 571px 853px #FFF, 1302px 301px #FFF, 9px 1344px #FFF, 418px 619px #FFF, 1941px 90px #FFF, 949px 640px #FFF, 179px 1783px #FFF, 1104px 360px #FFF, 1723px 370px #FFF, 1122px 1418px #FFF, 1374px 508px #FFF, 1108px 1089px #FFF, 1440px 1743px #FFF, 462px 1495px #FFF, 1187px 265px #FFF, 567px 74px #FFF, 557px 542px #FFF, 967px 673px #FFF, 825px 1971px #FFF, 988px 1260px #FFF, 710px 1206px #FFF, 538px 1805px #FFF, 137px 861px #FFF, 1922px 1313px #FFF, 481px 470px #FFF, 1224px 316px #FFF, 1979px 239px #FFF, 22px 1155px #FFF, 1640px 186px #FFF, 592px 1709px #FFF, 765px 170px #FFF, 129px 1750px #FFF, 788px 719px #FFF, 181px 1327px #FFF, 433px 1455px #FFF, 141px 450px #FFF, 1287px 1027px #FFF, 1278px 1462px #FFF, 688px 1526px #FFF, 463px 1604px #FFF, 1232px 297px #FFF, 920px 1227px #FFF, 1571px 1765px #FFF, 1482px 1316px #FFF, 759px 1463px #FFF, 950px 1166px #FFF, 1532px 1588px #FFF, 608px 267px #FFF, 1862px 1943px #FFF, 805px 717px #FFF, 1803px 1319px #FFF, 1821px 683px #FFF, 995px 1958px #FFF, 484px 932px #FFF, 366px 901px #FFF, 451px 1563px #FFF, 1704px 1471px #FFF, 1379px 44px #FFF, 1778px 472px #FFF, 419px 1806px #FFF, 1545px 222px #FFF, 1563px 777px #FFF, 39px 964px #FFF, 1620px 24px #FFF, 1151px 320px #FFF, 1940px 1426px #FFF, 1555px 1538px #FFF, 1747px 488px #FFF, 1348px 300px #FFF, 990px 538px #FFF, 780px 361px #FFF, 988px 971px #FFF, 1973px 1534px #FFF, 1542px 1829px #FFF, 1557px 216px #FFF, 1404px 641px #FFF, 47px 877px #FFF, 65px 1738px #FFF, 1895px 1798px #FFF, 56px 591px #FFF, 536px 906px #FFF, 568px 74px #FFF, 433px 462px #FFF, 727px 295px #FFF, 876px 1878px #FFF, 1891px 1946px #FFF, 1451px 493px #FFF, 1569px 226px #FFF, 879px 1351px #FFF, 1529px 43px #FFF, 33px 74px #FFF, 1516px 1924px #FFF, 878px 323px #FFF, 455px 1122px #FFF, 1943px 526px #FFF, 1456px 1060px #FFF, 1631px 979px #FFF, 1819px 1324px #FFF, 1660px 1192px #FFF, 1867px 1714px #FFF, 1928px 1940px #FFF, 1618px 744px #FFF, 979px 357px #FFF, 98px 1645px #FFF, 1898px 1207px #FFF, 1134px 16px #FFF, 1313px 1018px #FFF, 717px 812px #FFF, 1503px 234px #FFF, 1612px 188px #FFF, 29px 459px #FFF, 414px 1487px #FFF, 1223px 1730px #FFF, 1643px 1188px #FFF, 424px 767px #FFF, 1692px 1591px #FFF, 1265px 367px #FFF, 54px 832px #FFF, 410px 804px #FFF, 1397px 1242px #FFF, 549px 1484px #FFF, 721px 1088px #FFF, 472px 1240px #FFF, 1927px 514px #FFF, 1303px 1310px #FFF, 71px 1276px #FFF, 829px 1332px #FFF, 84px 1920px #FFF, 1088px 375px #FFF, 1659px 736px #FFF, 967px 294px #FFF, 651px 92px #FFF, 1572px 143px #FFF, 1680px 770px #FFF, 1873px 1289px #FFF, 1983px 821px #FFF, 448px 1090px #FFF, 890px 1332px #FFF, 836px 867px #FFF, 1867px 1213px #FFF, 1874px 1574px #FFF, 750px 1063px #FFF, 1297px 1971px #FFF, 1274px 1015px #FFF, 1628px 933px #FFF, 309px 1386px #FFF, 299px 1621px #FFF, 1973px 526px #FFF, 196px 1416px #FFF, 778px 715px #FFF, 1993px 1294px #FFF, 381px 435px #FFF, 1405px 681px #FFF, 1759px 1077px #FFF, 1764px 1748px #FFF, 168px 470px #FFF, 978px 781px #FFF, 110px 1666px #FFF, 835px 747px #FFF, 112px 95px #FFF, 604px 712px #FFF, 1121px 1752px #FFF, 393px 1782px #FFF, 1869px 830px #FFF, 1303px 348px #FFF, 427px 1546px #FFF, 761px 718px #FFF, 946px 674px #FFF, 832px 964px #FFF, 1607px 2000px #FFF, 1624px 1296px #FFF, 1093px 735px #FFF, 1865px 608px #FFF, 933px 1278px #FFF, 1402px 547px #FFF, 1865px 1211px #FFF, 109px 72px #FFF, 249px 1482px #FFF, 586px 1933px #FFF, 911px 1336px #FFF, 697px 853px #FFF, 987px 1797px #FFF, 1371px 933px #FFF, 492px 1896px #FFF, 998px 1866px #FFF, 518px 31px #FFF, 1873px 372px #FFF, 1025px 1308px #FFF, 1478px 965px #FFF, 1934px 934px #FFF, 1048px 1262px #FFF, 1839px 40px #FFF, 1399px 732px #FFF, 735px 416px #FFF, 621px 394px #FFF, 788px 1802px #FFF, 1918px 307px #FFF, 432px 1845px #FFF, 616px 481px #FFF, 921px 798px #FFF, 354px 597px #FFF, 1622px 214px #FFF, 1349px 1983px #FFF, 1033px 1622px #FFF, 1198px 407px #FFF, 1239px 1449px #FFF, 1278px 1978px #FFF, 426px 1264px #FFF, 507px 1341px #FFF, 1956px 818px #FFF, 1041px 277px #FFF, 1371px 639px #FFF, 1224px 419px #FFF, 211px 1106px #FFF, 847px 656px #FFF, 534px 1891px #FFF, 1289px 823px #FFF, 906px 482px #FFF, 347px 1837px #FFF, 1246px 1462px #FFF, 915px 1858px #FFF, 559px 1320px #FFF, 77px 1555px #FFF, 845px 1743px #FFF, 313px 1414px #FFF, 188px 252px #FFF, 509px 637px #FFF, 374px 142px #FFF, 1397px 474px #FFF, 458px 1197px #FFF, 292px 619px #FFF, 1749px 14px #FFF, 1638px 24px #FFF, 563px 1752px #FFF, 1940px 1065px #FFF, 1145px 1030px #FFF, 894px 1470px #FFF, 444px 32px #FFF, 1341px 1136px #FFF, 1941px 412px #FFF, 1328px 785px #FFF, 161px 1740px #FFF, 948px 829px #FFF, 933px 823px #FFF, 1709px 507px #FFF, 1366px 1821px #FFF, 720px 731px #FFF, 162px 682px #FFF, 1684px 882px #FFF, 134px 497px #FFF, 1659px 1701px #FFF, 1186px 446px #FFF, 911px 1435px #FFF, 1814px 1028px #FFF, 1234px 1520px #FFF, 1186px 23px #FFF, 318px 87px #FFF, 1179px 837px #FFF, 1071px 46px #FFF, 1125px 1862px #FFF, 94px 261px #FFF, 1574px 282px #FFF, 1039px 815px #FFF, 1776px 1472px #FFF, 867px 473px #FFF, 901px 215px #FFF, 862px 630px #FFF, 1480px 1673px #FFF, 411px 1896px #FFF, 1335px 944px #FFF, 148px 1235px #FFF, 57px 140px #FFF, 447px 651px #FFF, 1414px 1651px #FFF, 209px 1770px #FFF, 1800px 1590px #FFF, 1304px 1px #FFF, 279px 771px #FFF, 1770px 1398px #FFF, 724px 1201px #FFF, 245px 1145px #FFF, 172px 1951px #FFF, 284px 236px #FFF, 1905px 1307px #FFF, 1948px 574px #FFF, 283px 669px #FFF, 247px 384px #FFF, 224px 619px #FFF, 128px 772px #FFF, 1698px 1405px #FFF, 830px 505px #FFF, 1938px 397px #FFF, 1772px 1001px #FFF, 1454px 808px #FFF, 304px 561px #FFF, 1321px 966px #FFF, 735px 1368px #FFF, 894px 345px #FFF, 1217px 1997px #FFF, 892px 1342px #FFF, 353px 379px #FFF, 1382px 1156px #FFF, 164px 1239px #FFF, 1268px 1859px #FFF, 1385px 1721px #FFF, 16px 283px #FFF, 1819px 200px #FFF, 660px 1111px #FFF, 1679px 1728px #FFF, 463px 596px #FFF, 217px 1834px #FFF, 1879px 538px #FFF, 304px 906px #FFF, 1327px 1347px #FFF, 1226px 1579px #FFF, 1786px 1616px #FFF, 1234px 1982px #FFF, 1868px 1862px #FFF, 814px 948px #FFF, 178px 1837px #FFF, 571px 1701px #FFF, 106px 566px #FFF, 270px 925px #FFF, 1417px 248px #FFF, 609px 1551px #FFF, 992px 1825px #FFF, 1515px 1999px #FFF, 1167px 914px #FFF, 1698px 490px #FFF, 189px 1463px #FFF, 928px 612px #FFF, 1714px 803px #FFF, 535px 402px #FFF, 1000px 379px #FFF, 1610px 574px #FFF, 1882px 1155px #FFF, 1425px 1514px #FFF, 417px 1987px #FFF, 1681px 1059px #FFF, 841px 762px #FFF, 1886px 1098px #FFF, 1785px 236px #FFF, 1950px 950px #FFF, 444px 1937px #FFF, 1364px 540px #FFF, 1971px 225px #FFF, 1624px 868px #FFF, 869px 640px #FFF, 1637px 559px #FFF, 20px 823px #FFF, 409px 177px #FFF, 1804px 1626px #FFF, 388px 527px #FFF, 1385px 1734px #FFF, 988px 1310px #FFF, 443px 599px #FFF, 1780px 434px #FFF, 654px 419px #FFF, 268px 1424px #FFF, 1971px 40px #FFF, 360px 1834px #FFF, 875px 1930px #FFF, 1866px 1885px #FFF, 453px 1670px #FFF, 1696px 1337px #FFF, 604px 1887px #FFF, 1405px 769px #FFF, 1546px 897px #FFF, 595px 1975px #FFF, 32px 1765px #FFF, 896px 1150px #FFF, 1818px 95px #FFF, 444px 49px #FFF, 589px 1796px #FFF, 764px 1965px #FFF, 920px 1803px #FFF, 403px 1997px #FFF, 833px 1282px #FFF, 1127px 1770px #FFF, 1810px 77px #FFF, 1214px 1102px #FFF, 364px 401px #FFF, 1139px 1191px #FFF, 916px 1907px #FFF, 870px 290px #FFF, 688px 678px #FFF, 1523px 34px #FFF, 1265px 1082px #FFF, 1394px 1080px #FFF, 1787px 1738px #FFF, 1682px 755px #FFF, 1955px 832px #FFF, 546px 1577px #FFF, 1062px 1561px #FFF, 344px 826px #FFF, 1442px 782px #FFF, 467px 1477px #FFF, 879px 1439px #FFF, 1672px 268px #FFF, 1317px 1355px #FFF, 1980px 1965px #FFF, 688px 1465px #FFF, 1131px 872px #FFF, 1301px 1656px #FFF, 974px 583px #FFF, 1613px 1467px #FFF, 1976px 1995px #FFF, 1377px 760px #FFF, 1367px 387px #FFF, 1880px 191px #FFF, 711px 876px #FFF, 539px 152px #FFF, 545px 1809px #FFF, 920px 970px #FFF, 1154px 1355px #FFF, 1968px 94px #FFF, 1703px 490px #FFF, 380px 146px #FFF, 1561px 785px #FFF, 1930px 1385px #FFF, 519px 1091px #FFF, 269px 570px #FFF, 109px 1326px #FFF, 1476px 969px #FFF, 1999px 1885px #FFF, 341px 1238px #FFF, 1105px 1076px #FFF, 596px 88px #FFF, 937px 492px #FFF, 1339px 1673px #FFF, 1967px 762px #FFF, 65px 952px #FFF, 111px 93px #FFF, 1011px 1684px #FFF, 377px 1430px #FFF, 1011px 386px #FFF, 1162px 421px #FFF, 196px 617px #FFF, 1407px 1141px #FFF, 1562px 572px #FFF, 316px 690px #FFF, 1600px 1980px #FFF, 1545px 1254px #FFF, 680px 1120px #FFF, 575px 1284px #FFF, 179px 1470px #FFF, 1496px 1506px #FFF, 977px 1376px #FFF, 1282px 708px #FFF, 408px 1427px #FFF, 1173px 1597px #FFF, 1120px 1755px #FFF, 974px 520px #FFF, 979px 384px #FFF, 622px 1116px #FFF, 1307px 866px #FFF, 1188px 1596px #FFF, 858px 1947px #FFF, 861px 1373px #FFF, 857px 43px #FFF, 1878px 499px #FFF, 1297px 535px #FFF, 870px 1286px #FFF, 1452px 448px #FFF, 906px 72px #FFF, 1450px 872px #FFF, 1607px 1755px #FFF, 1071px 1959px #FFF, 976px 879px #FFF, 1435px 284px #FFF, 1601px 496px #FFF, 671px 1713px #FFF, 356px 1148px #FFF, 837px 867px #FFF, 246px 858px #FFF, 1031px 1594px #FFF, 571px 214px #FFF, 1012px 1329px #FFF, 1566px 1142px #FFF, 219px 1376px #FFF, 1580px 1454px #FFF, 690px 1037px #FFF, 1940px 756px #FFF, 1755px 850px #FFF, 1037px 363px #FFF, 25px 515px #FFF, 806px 1571px #FFF, 1266px 1398px #FFF, 695px 791px #FFF, 1838px 950px #FFF, 1578px 27px #FFF, 1692px 1581px #FFF, 1817px 1040px #FFF, 1781px 238px #FFF, 1052px 895px #FFF, 398px 440px #FFF, 1643px 325px #FFF, 79px 848px #FFF, 1295px 326px #FFF, 293px 81px #FFF, 1202px 1580px #FFF, 1441px 100px #FFF, 1295px 1465px #FFF, 1132px 1275px #FFF, 774px 704px #FFF, 1109px 1546px #FFF, 557px 1390px #FFF, 1253px 1224px #FFF, 1063px 1618px #FFF, 1793px 440px #FFF, 890px 1988px #FFF, 814px 424px #FFF, 1390px 1280px #FFF, 1127px 907px #FFF, 1044px 1368px #FFF, 1317px 876px #FFF, 762px 638px #FFF, 965px 747px #FFF, 755px 1945px #FFF, 706px 414px #FFF, 1842px 1673px #FFF, 1158px 1336px #FFF, 989px 1955px #FFF, 1857px 89px #FFF, 1659px 343px #FFF, 509px 1385px #FFF, 1620px 758px #FFF, 1958px 1064px #FFF, 178px 341px #FFF, 1500px 808px #FFF, 20px 1646px #FFF, 1572px 870px #FFF, 1821px 1377px #FFF, 328px 1965px #FFF, 903px 616px #FFF, 1731px 1599px #FFF, 267px 856px #FFF;
}

#stars2 {
  width: 2px;
  height: 2px;
  background: transparent;
  box-shadow: 921px 1554px #FFF, 1944px 550px #FFF, 1696px 1632px #FFF, 16px 1899px #FFF, 1894px 130px #FFF, 77px 262px #FFF, 22px 1159px #FFF, 933px 1206px #FFF, 1660px 482px #FFF, 1067px 1154px #FFF, 468px 625px #FFF, 1408px 1687px #FFF, 153px 1200px #FFF, 887px 1966px #FFF, 1260px 514px #FFF, 1167px 1158px #FFF, 790px 553px #FFF, 1103px 758px #FFF, 226px 1028px #FFF, 1340px 1760px #FFF, 1712px 528px #FFF, 114px 1693px #FFF, 185px 572px #FFF, 1566px 1793px #FFF, 317px 1501px #FFF, 846px 530px #FFF, 1585px 1437px #FFF, 1335px 1009px #FFF, 1768px 436px #FFF, 1131px 666px #FFF, 27px 1543px #FFF, 1778px 1861px #FFF, 1496px 30px #FFF, 1359px 1226px #FFF, 416px 135px #FFF, 1675px 673px #FFF, 296px 524px #FFF, 432px 1822px #FFF, 1995px 416px #FFF, 1206px 1846px #FFF, 542px 603px #FFF, 1811px 1083px #FFF, 1125px 1900px #FFF, 4px 1410px #FFF, 665px 1674px #FFF, 982px 365px #FFF, 809px 534px #FFF, 116px 1381px #FFF, 727px 439px #FFF, 1674px 1407px #FFF, 976px 1762px #FFF, 1585px 28px #FFF, 1916px 624px #FFF, 1716px 1118px #FFF, 1022px 177px #FFF, 807px 619px #FFF, 1657px 338px #FFF, 1608px 1259px #FFF, 405px 1890px #FFF, 433px 1978px #FFF, 1457px 1495px #FFF, 175px 989px #FFF, 850px 1044px #FFF, 170px 444px #FFF, 1623px 71px #FFF, 977px 1319px #FFF, 440px 464px #FFF, 51px 1209px #FFF, 783px 1274px #FFF, 1296px 244px #FFF, 1260px 94px #FFF, 652px 905px #FFF, 805px 1307px #FFF, 947px 822px #FFF, 384px 268px #FFF, 1856px 1782px #FFF, 459px 1844px #FFF, 1679px 473px #FFF, 673px 1832px #FFF, 96px 345px #FFF, 1268px 428px #FFF, 788px 1138px #FFF, 1242px 867px #FFF, 652px 831px #FFF, 993px 1706px #FFF, 1337px 64px #FFF, 1092px 624px #FFF, 674px 1344px #FFF, 1036px 405px #FFF, 996px 1371px #FFF, 1906px 1410px #FFF, 1285px 1079px #FFF, 1756px 583px #FFF, 404px 380px #FFF, 1739px 1620px #FFF, 1253px 372px #FFF, 520px 620px #FFF, 1842px 852px #FFF, 490px 387px #FFF, 1251px 143px #FFF, 1814px 537px #FFF, 1405px 623px #FFF, 1236px 1186px #FFF, 1286px 896px #FFF, 1626px 990px #FFF, 31px 1067px #FFF, 1288px 939px #FFF, 763px 338px #FFF, 713px 1515px #FFF, 859px 1621px #FFF, 1720px 1984px #FFF, 796px 1743px #FFF, 1439px 1587px #FFF, 965px 412px #FFF, 775px 1168px #FFF, 1192px 956px #FFF, 368px 1075px #FFF, 1484px 1154px #FFF, 1784px 547px #FFF, 815px 675px #FFF, 1387px 890px #FFF, 1665px 1733px #FFF, 1948px 429px #FFF, 1665px 92px #FFF, 1806px 919px #FFF, 1712px 494px #FFF, 577px 1922px #FFF, 820px 1228px #FFF, 678px 1745px #FFF, 1421px 586px #FFF, 788px 208px #FFF, 380px 250px #FFF, 748px 977px #FFF, 1637px 337px #FFF, 851px 1514px #FFF, 1487px 1410px #FFF, 1776px 710px #FFF, 544px 453px #FFF, 1707px 1932px #FFF, 1121px 1642px #FFF, 1227px 391px #FFF, 583px 833px #FFF, 658px 278px #FFF, 345px 1388px #FFF, 1529px 1419px #FFF, 233px 1008px #FFF, 892px 943px #FFF, 1431px 1091px #FFF, 1524px 316px #FFF, 1547px 192px #FFF, 976px 36px #FFF, 1648px 1053px #FFF, 1833px 1572px #FFF, 1677px 936px #FFF, 589px 1755px #FFF, 978px 1875px #FFF, 1508px 412px #FFF, 1242px 439px #FFF, 1263px 40px #FFF, 1427px 1736px #FFF, 639px 906px #FFF, 1349px 373px #FFF, 1055px 969px #FFF, 602px 95px #FFF, 224px 1805px #FFF, 1129px 837px #FFF, 1110px 1358px #FFF, 1067px 1752px #FFF, 391px 1389px #FFF, 885px 1979px #FFF, 1188px 414px #FFF, 1931px 325px #FFF, 1853px 1918px #FFF, 636px 1313px #FFF, 1236px 1913px #FFF, 1801px 780px #FFF, 633px 529px #FFF, 1500px 33px #FFF, 1387px 1045px #FFF, 832px 1281px #FFF, 1880px 1845px #FFF, 1477px 1096px #FFF, 1457px 698px #FFF, 1658px 1049px #FFF, 1957px 1151px #FFF, 1561px 1593px #FFF, 627px 250px #FFF, 975px 1575px #FFF, 68px 998px #FFF, 951px 85px #FFF, 280px 431px #FFF, 1683px 1745px #FFF, 322px 778px #FFF, 841px 888px #FFF, 1895px 1883px #FFF, 700px 568px #FFF, 1846px 442px #FFF, 91px 1650px #FFF, 970px 917px #FFF, 1585px 452px #FFF;
  animation: animStar 100s linear infinite;
}

#stars2:after {
  content: " ";
  position: absolute;
  top: 2000px;
  width: 2px;
  height: 2px;
  background: transparent;
  box-shadow: 921px 1554px #FFF, 1944px 550px #FFF, 1696px 1632px #FFF, 16px 1899px #FFF, 1894px 130px #FFF, 77px 262px #FFF, 22px 1159px #FFF, 933px 1206px #FFF, 1660px 482px #FFF, 1067px 1154px #FFF, 468px 625px #FFF, 1408px 1687px #FFF, 153px 1200px #FFF, 887px 1966px #FFF, 1260px 514px #FFF, 1167px 1158px #FFF, 790px 553px #FFF, 1103px 758px #FFF, 226px 1028px #FFF, 1340px 1760px #FFF, 1712px 528px #FFF, 114px 1693px #FFF, 185px 572px #FFF, 1566px 1793px #FFF, 317px 1501px #FFF, 846px 530px #FFF, 1585px 1437px #FFF, 1335px 1009px #FFF, 1768px 436px #FFF, 1131px 666px #FFF, 27px 1543px #FFF, 1778px 1861px #FFF, 1496px 30px #FFF, 1359px 1226px #FFF, 416px 135px #FFF, 1675px 673px #FFF, 296px 524px #FFF, 432px 1822px #FFF, 1995px 416px #FFF, 1206px 1846px #FFF, 542px 603px #FFF, 1811px 1083px #FFF, 1125px 1900px #FFF, 4px 1410px #FFF, 665px 1674px #FFF, 982px 365px #FFF, 809px 534px #FFF, 116px 1381px #FFF, 727px 439px #FFF, 1674px 1407px #FFF, 976px 1762px #FFF, 1585px 28px #FFF, 1916px 624px #FFF, 1716px 1118px #FFF, 1022px 177px #FFF, 807px 619px #FFF, 1657px 338px #FFF, 1608px 1259px #FFF, 405px 1890px #FFF, 433px 1978px #FFF, 1457px 1495px #FFF, 175px 989px #FFF, 850px 1044px #FFF, 170px 444px #FFF, 1623px 71px #FFF, 977px 1319px #FFF, 440px 464px #FFF, 51px 1209px #FFF, 783px 1274px #FFF, 1296px 244px #FFF, 1260px 94px #FFF, 652px 905px #FFF, 805px 1307px #FFF, 947px 822px #FFF, 384px 268px #FFF, 1856px 1782px #FFF, 459px 1844px #FFF, 1679px 473px #FFF, 673px 1832px #FFF, 96px 345px #FFF, 1268px 428px #FFF, 788px 1138px #FFF, 1242px 867px #FFF, 652px 831px #FFF, 993px 1706px #FFF, 1337px 64px #FFF, 1092px 624px #FFF, 674px 1344px #FFF, 1036px 405px #FFF, 996px 1371px #FFF, 1906px 1410px #FFF, 1285px 1079px #FFF, 1756px 583px #FFF, 404px 380px #FFF, 1739px 1620px #FFF, 1253px 372px #FFF, 520px 620px #FFF, 1842px 852px #FFF, 490px 387px #FFF, 1251px 143px #FFF, 1814px 537px #FFF, 1405px 623px #FFF, 1236px 1186px #FFF, 1286px 896px #FFF, 1626px 990px #FFF, 31px 1067px #FFF, 1288px 939px #FFF, 763px 338px #FFF, 713px 1515px #FFF, 859px 1621px #FFF, 1720px 1984px #FFF, 796px 1743px #FFF, 1439px 1587px #FFF, 965px 412px #FFF, 775px 1168px #FFF, 1192px 956px #FFF, 368px 1075px #FFF, 1484px 1154px #FFF, 1784px 547px #FFF, 815px 675px #FFF, 1387px 890px #FFF, 1665px 1733px #FFF, 1948px 429px #FFF, 1665px 92px #FFF, 1806px 919px #FFF, 1712px 494px #FFF, 577px 1922px #FFF, 820px 1228px #FFF, 678px 1745px #FFF, 1421px 586px #FFF, 788px 208px #FFF, 380px 250px #FFF, 748px 977px #FFF, 1637px 337px #FFF, 851px 1514px #FFF, 1487px 1410px #FFF, 1776px 710px #FFF, 544px 453px #FFF, 1707px 1932px #FFF, 1121px 1642px #FFF, 1227px 391px #FFF, 583px 833px #FFF, 658px 278px #FFF, 345px 1388px #FFF, 1529px 1419px #FFF, 233px 1008px #FFF, 892px 943px #FFF, 1431px 1091px #FFF, 1524px 316px #FFF, 1547px 192px #FFF, 976px 36px #FFF, 1648px 1053px #FFF, 1833px 1572px #FFF, 1677px 936px #FFF, 589px 1755px #FFF, 978px 1875px #FFF, 1508px 412px #FFF, 1242px 439px #FFF, 1263px 40px #FFF, 1427px 1736px #FFF, 639px 906px #FFF, 1349px 373px #FFF, 1055px 969px #FFF, 602px 95px #FFF, 224px 1805px #FFF, 1129px 837px #FFF, 1110px 1358px #FFF, 1067px 1752px #FFF, 391px 1389px #FFF, 885px 1979px #FFF, 1188px 414px #FFF, 1931px 325px #FFF, 1853px 1918px #FFF, 636px 1313px #FFF, 1236px 1913px #FFF, 1801px 780px #FFF, 633px 529px #FFF, 1500px 33px #FFF, 1387px 1045px #FFF, 832px 1281px #FFF, 1880px 1845px #FFF, 1477px 1096px #FFF, 1457px 698px #FFF, 1658px 1049px #FFF, 1957px 1151px #FFF, 1561px 1593px #FFF, 627px 250px #FFF, 975px 1575px #FFF, 68px 998px #FFF, 951px 85px #FFF, 280px 431px #FFF, 1683px 1745px #FFF, 322px 778px #FFF, 841px 888px #FFF, 1895px 1883px #FFF, 700px 568px #FFF, 1846px 442px #FFF, 91px 1650px #FFF, 970px 917px #FFF, 1585px 452px #FFF;
}

#stars3 {
  width: 3px;
  height: 3px;
  background: transparent;
  box-shadow: 1679px 1408px #FFF, 1970px 1504px #FFF, 1789px 965px #FFF, 698px 234px #FFF, 1733px 1854px #FFF, 1060px 271px #FFF, 719px 1744px #FFF, 1707px 1847px #FFF, 1710px 432px #FFF, 1325px 1585px #FFF, 92px 577px #FFF, 163px 1938px #FFF, 1885px 123px #FFF, 1566px 1753px #FFF, 1288px 21px #FFF, 1396px 1908px #FFF, 675px 1466px #FFF, 734px 1557px #FFF, 941px 1885px #FFF, 1692px 6px #FFF, 115px 1183px #FFF, 639px 1044px #FFF, 1171px 1982px #FFF, 1801px 1078px #FFF, 648px 820px #FFF, 1885px 1984px #FFF, 268px 1729px #FFF, 1388px 181px #FFF, 1741px 1280px #FFF, 1719px 1080px #FFF, 12px 932px #FFF, 489px 157px #FFF, 1910px 790px #FFF, 115px 44px #FFF, 1748px 1458px #FFF, 282px 109px #FFF, 1100px 1528px #FFF, 543px 598px #FFF, 1320px 1188px #FFF, 1124px 839px #FFF, 1406px 1289px #FFF, 472px 1376px #FFF, 852px 286px #FFF, 510px 860px #FFF, 700px 306px #FFF, 1822px 1302px #FFF, 15px 19px #FFF, 1360px 420px #FFF, 1483px 42px #FFF, 1287px 1867px #FFF, 1105px 1322px #FFF, 745px 161px #FFF, 431px 1722px #FFF, 855px 1254px #FFF, 860px 1784px #FFF, 1578px 1955px #FFF, 1085px 461px #FFF, 472px 690px #FFF, 23px 1152px #FFF, 1625px 601px #FFF, 1177px 1692px #FFF, 397px 1984px #FFF, 10px 1164px #FFF, 1132px 1557px #FFF, 438px 817px #FFF, 1590px 1236px #FFF, 1037px 1616px #FFF, 533px 941px #FFF, 1163px 1992px #FFF, 1451px 1081px #FFF, 1335px 1578px #FFF, 503px 1556px #FFF, 197px 1725px #FFF, 511px 1397px #FFF, 1514px 1164px #FFF, 1249px 148px #FFF, 947px 1849px #FFF, 1258px 1426px #FFF, 255px 1937px #FFF, 23px 529px #FFF, 578px 230px #FFF, 925px 767px #FFF, 903px 365px #FFF, 1861px 451px #FFF, 1813px 912px #FFF, 1597px 637px #FFF, 195px 626px #FFF, 130px 404px #FFF, 725px 408px #FFF, 1916px 843px #FFF, 1336px 239px #FFF, 1568px 1390px #FFF, 139px 126px #FFF, 1287px 1271px #FFF, 731px 465px #FFF, 1959px 1465px #FFF, 909px 169px #FFF, 838px 1332px #FFF, 464px 1037px #FFF, 1893px 233px #FFF;
  animation: animStar 150s linear infinite;
}

#stars3:after {
  content: " ";
  position: absolute;
  top: 2000px;
  width: 3px;
  height: 3px;
  background: transparent;
  box-shadow: 1679px 1408px #FFF, 1970px 1504px #FFF, 1789px 965px #FFF, 698px 234px #FFF, 1733px 1854px #FFF, 1060px 271px #FFF, 719px 1744px #FFF, 1707px 1847px #FFF, 1710px 432px #FFF, 1325px 1585px #FFF, 92px 577px #FFF, 163px 1938px #FFF, 1885px 123px #FFF, 1566px 1753px #FFF, 1288px 21px #FFF, 1396px 1908px #FFF, 675px 1466px #FFF, 734px 1557px #FFF, 941px 1885px #FFF, 1692px 6px #FFF, 115px 1183px #FFF, 639px 1044px #FFF, 1171px 1982px #FFF, 1801px 1078px #FFF, 648px 820px #FFF, 1885px 1984px #FFF, 268px 1729px #FFF, 1388px 181px #FFF, 1741px 1280px #FFF, 1719px 1080px #FFF, 12px 932px #FFF, 489px 157px #FFF, 1910px 790px #FFF, 115px 44px #FFF, 1748px 1458px #FFF, 282px 109px #FFF, 1100px 1528px #FFF, 543px 598px #FFF, 1320px 1188px #FFF, 1124px 839px #FFF, 1406px 1289px #FFF, 472px 1376px #FFF, 852px 286px #FFF, 510px 860px #FFF, 700px 306px #FFF, 1822px 1302px #FFF, 15px 19px #FFF, 1360px 420px #FFF, 1483px 42px #FFF, 1287px 1867px #FFF, 1105px 1322px #FFF, 745px 161px #FFF, 431px 1722px #FFF, 855px 1254px #FFF, 860px 1784px #FFF, 1578px 1955px #FFF, 1085px 461px #FFF, 472px 690px #FFF, 23px 1152px #FFF, 1625px 601px #FFF, 1177px 1692px #FFF, 397px 1984px #FFF, 10px 1164px #FFF, 1132px 1557px #FFF, 438px 817px #FFF, 1590px 1236px #FFF, 1037px 1616px #FFF, 533px 941px #FFF, 1163px 1992px #FFF, 1451px 1081px #FFF, 1335px 1578px #FFF, 503px 1556px #FFF, 197px 1725px #FFF, 511px 1397px #FFF, 1514px 1164px #FFF, 1249px 148px #FFF, 947px 1849px #FFF, 1258px 1426px #FFF, 255px 1937px #FFF, 23px 529px #FFF, 578px 230px #FFF, 925px 767px #FFF, 903px 365px #FFF, 1861px 451px #FFF, 1813px 912px #FFF, 1597px 637px #FFF, 195px 626px #FFF, 130px 404px #FFF, 725px 408px #FFF, 1916px 843px #FFF, 1336px 239px #FFF, 1568px 1390px #FFF, 139px 126px #FFF, 1287px 1271px #FFF, 731px 465px #FFF, 1959px 1465px #FFF, 909px 169px #FFF, 838px 1332px #FFF, 464px 1037px #FFF, 1893px 233px #FFF;
}

@keyframes animate {
  to {
    transform: rotate(1turn);
  }
}

@keyframes animStar {
  from {
    transform: translateY(0px);
  }

  to {
    transform: translateY(-2000px);
  }
}

.s {
  color: #a4a5fd;
}
</style>


// WEBPACK FOOTER //
// src/components/graphically/fishingShow.vue